export const businessIntroData = {
	v: '5.11.0',
	fr: 60,
	ip: 0,
	op: 630,
	w: 400,
	h: 400,
	nm: 'Export Issues',
	ddd: 0,
	assets: [
		{
			id: 'comp_0',
			nm: 'Progress Card',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 0,
					nm: 'Progress Bards Animate',
					refId: 'comp_1',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [62, 44, 0], ix: 2, l: 2 },
						a: { a: 0, k: [20, 19, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					w: 40,
					h: 38,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 0,
					nm: 'Progress Card BG',
					refId: 'comp_2',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 36, 0], ix: 2, l: 2 },
						a: { a: 0, k: [63, 36, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					w: 126,
					h: 72,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_1',
			nm: 'Progress Bards Animate',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Rectangle 368',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.09], y: [1] },
									o: { x: [0.167], y: [0.167] },
									t: 480,
									s: [0],
								},
								{ t: 495, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [0, 36, 0], ix: 2, l: 2 },
						a: { a: 0, k: [-4, -1, 0], ix: 1, l: 2 },
						s: {
							a: 1,
							k: [
								{
									i: { x: [0.09, 0.667, 0.667], y: [1, 1, 1] },
									o: { x: [0.167, 0.167, 0.167], y: [0.167, 0, 0] },
									t: 480,
									s: [0, 100, 100],
								},
								{ t: 495, s: [100, 100, 100] },
							],
							ix: 6,
							l: 2,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [8, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 4, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.340000033379, 0.615000128746, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 368',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Rectangle 367',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.09], y: [1] },
									o: { x: [0.167], y: [0.167] },
									t: 480,
									s: [0],
								},
								{ t: 495, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [0, 24, 0], ix: 2, l: 2 },
						a: { a: 0, k: [-8, -1, 0], ix: 1, l: 2 },
						s: {
							a: 1,
							k: [
								{
									i: { x: [0.09, 0.667, 0.667], y: [1, 1, 1] },
									o: { x: [0.167, 0.167, 0.167], y: [0.167, 0, 0] },
									t: 480,
									s: [0, 100, 100],
								},
								{ t: 495, s: [100, 100, 100] },
							],
							ix: 6,
							l: 2,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [16, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 4, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.960784316063, 0.803921580315, 0.278431385756, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 367',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Rectangle 366',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.09], y: [1] },
									o: { x: [0.167], y: [0.167] },
									t: 480,
									s: [0],
								},
								{ t: 495, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [0, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [-12, -1, 0], ix: 1, l: 2 },
						s: {
							a: 1,
							k: [
								{
									i: { x: [0.09, 0.667, 0.667], y: [1, 1, 1] },
									o: { x: [0.167, 0.167, 0.167], y: [0.167, 0, 0] },
									t: 480,
									s: [0, 100, 100],
								},
								{ t: 495, s: [100, 100, 100] },
							],
							ix: 6,
							l: 2,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [24, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 4, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.972549021244, 0.443137258291, 0.407843142748, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 366',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Rectangle 768',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [0, 36, 0], ix: 2, l: 2 },
						a: { a: 0, k: [-20, -1, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [40, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 765',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Rectangle 767',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [0, 24, 0], ix: 2, l: 2 },
						a: { a: 0, k: [-20, -1, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [40, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 765',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 6,
					ty: 4,
					nm: 'Rectangle 765',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [0, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [-20, -1, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [40, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 765',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 7,
					ty: 4,
					nm: 'Rectangle 365',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.833], y: [0.833] },
									o: { x: [0.167], y: [0.167] },
									t: 480,
									s: [0],
								},
								{ t: 495, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [0, 0, 0], ix: 2, l: 2 },
						a: { a: 0, k: [-16, -1, 0], ix: 1, l: 2 },
						s: {
							a: 1,
							k: [
								{
									i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
									o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
									t: 480,
									s: [0, 100, 100],
								},
								{ t: 495, s: [100, 100, 100] },
							],
							ix: 6,
							l: 2,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [32, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 4, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.29411765933, 0.807843148708, 0.592156887054, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 365',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 8,
					ty: 4,
					nm: 'Rectangle 766',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [0, 0, 0], ix: 2, l: 2 },
						a: { a: 0, k: [-20, -1, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [40, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 765',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 9,
					ty: 4,
					nm: 'Progress Bards Animate',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [20, 19, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [40, 38], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 0, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Progress Bards Animate',
							np: 1,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_2',
			nm: 'Progress Card BG',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Rectangle 754',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [49, 14, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [90, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 754',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Rectangle 751',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [14, 7, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [20, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.800000011921, 0.878431379795, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 751',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Rectangle 771',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [112, 62, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 6, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.04699999094, 0.399500161409, 0.893000006676, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 771',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Rectangle 767',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [100, 62, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 767',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Rectangle 763',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 62, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [18, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 763',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 6,
					ty: 4,
					nm: 'Rectangle 770',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [112, 50, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 6, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.04699999094, 0.399500161409, 0.893000006676, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 770',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 7,
					ty: 4,
					nm: 'Rectangle 766',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [100, 50, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 766',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 8,
					ty: 4,
					nm: 'Rectangle 762',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 50, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [18, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 762',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 9,
					ty: 4,
					nm: 'Rectangle 769',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [112, 38, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 6, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.04699999094, 0.399500161409, 0.893000006676, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 769',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 10,
					ty: 4,
					nm: 'Rectangle 765',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [100, 38, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 765',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 11,
					ty: 4,
					nm: 'Rectangle 761',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 38, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [18, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 761',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 12,
					ty: 4,
					nm: 'Rectangle 768',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [112, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 6, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.04699999094, 0.399500161409, 0.893000006676, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 768',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 13,
					ty: 4,
					nm: 'Rectangle 764',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [100, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 764',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 14,
					ty: 4,
					nm: 'Rectangle 760',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [18, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 760',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 15,
					ty: 4,
					nm: 'Ellipse 11',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [8, 62, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [8, 8], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.996078431606, 0.870588243008, 0.784313738346, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 11',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 16,
					ty: 4,
					nm: 'Ellipse 10',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [8, 50, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [8, 8], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.729411780834, 0.952941179276, 0.858823537827, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 10',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 17,
					ty: 4,
					nm: 'Ellipse 9',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [8, 38, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [8, 8], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 9',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 18,
					ty: 4,
					nm: 'Ellipse 8',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [8, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [8, 8], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.874400138855, 0.848000109196, 0.991999924183, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 19,
					ty: 4,
					nm: 'Rectangle 749',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 36, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, -2.209],
												[0, 0],
												[0, 0],
												[0, 0],
												[2.209, 0],
											],
											o: [
												[-2.209, 0],
												[0, 0],
												[0, 0],
												[0, 0],
												[0, -2.209],
												[0, 0],
											],
											v: [
												[-59, -36],
												[-63, -32],
												[-63, 36],
												[63, 36],
												[63, -32],
												[59, -36],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 749',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 20,
					ty: 4,
					nm: 'Progress Card BG',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 36, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [126, 72], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 0, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Progress Card BG',
							np: 1,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_3',
			nm: 'Bars Card',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 0,
					nm: 'Bars Animate',
					refId: 'comp_4',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 44, 0], ix: 2, l: 2 },
						a: { a: 0, k: [46, 16, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					w: 92,
					h: 32,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 0,
					nm: 'Bars card BG',
					refId: 'comp_5',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 36, 0], ix: 2, l: 2 },
						a: { a: 0, k: [63, 36, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					w: 126,
					h: 72,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_4',
			nm: 'Bars Animate',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Blue Bar',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.667], y: [1] },
									o: { x: [0.167], y: [0.167] },
									t: 484,
									s: [0],
								},
								{ t: 494, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [86, 32, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 2, 0], ix: 1, l: 2 },
						s: {
							a: 1,
							k: [
								{
									i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
									o: { x: [0.167, 0.167, 0.167], y: [0, 0.167, 0] },
									t: 484,
									s: [100, 0, 100],
								},
								{ t: 494, s: [100, 100, 100] },
							],
							ix: 6,
							l: 2,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0, 0.333333492279, 0.800000011921, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Blue Bar',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Sky Bar',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.667], y: [1] },
									o: { x: [0.167], y: [0.167] },
									t: 480,
									s: [0],
								},
								{ t: 490, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [66, 32, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 12, 0], ix: 1, l: 2 },
						s: {
							a: 1,
							k: [
								{
									i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
									o: { x: [0.167, 0.167, 0.167], y: [0, 0.167, 0] },
									t: 480,
									s: [100, 0, 100],
								},
								{ t: 490, s: [100, 100, 100] },
							],
							ix: 6,
							l: 2,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 24], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.340000033379, 0.615000128746, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Sky Bar',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Yellow Bar',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.667], y: [1] },
									o: { x: [0.167], y: [0.167] },
									t: 475,
									s: [0],
								},
								{ t: 485, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [46, 32, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 16, 0], ix: 1, l: 2 },
						s: {
							a: 1,
							k: [
								{
									i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
									o: { x: [0.167, 0.167, 0.167], y: [0, 0.167, 0] },
									t: 475,
									s: [100, 0, 100],
								},
								{ t: 485, s: [100, 100, 100] },
							],
							ix: 6,
							l: 2,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 32], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.960784316063, 0.803921580315, 0.278431385756, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Yellow Bar',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Pink Bar',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.667], y: [1] },
									o: { x: [0.167], y: [0.167] },
									t: 469,
									s: [0],
								},
								{ t: 479, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [26, 32, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 8, 0], ix: 1, l: 2 },
						s: {
							a: 1,
							k: [
								{
									i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
									o: { x: [0.167, 0.167, 0.167], y: [0, 0.167, 0] },
									t: 469,
									s: [100, 0, 100],
								},
								{ t: 479, s: [100, 100, 100] },
							],
							ix: 6,
							l: 2,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 16], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.972549021244, 0.443137258291, 0.407843142748, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Pink Bar',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Red Bar',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.667], y: [1] },
									o: { x: [0.167], y: [0.167] },
									t: 465,
									s: [0],
								},
								{ t: 475, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [6, 32, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 5, 0], ix: 1, l: 2 },
						s: {
							a: 1,
							k: [
								{
									i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
									o: { x: [0.167, 0.167, 0.167], y: [0, 0.167, 0] },
									t: 465,
									s: [100, 0, 100],
								},
								{ t: 475, s: [100, 100, 100] },
							],
							ix: 6,
							l: 2,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 10], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.78823530674, 0.215686276555, 0.172549024224, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Red Bar',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_5',
			nm: 'Bars card BG',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Rectangle 754',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [49, 16, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [90, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 754',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Rectangle 751',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [14, 7, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [20, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.800000011921, 0.878431379795, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 751',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Line 37',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 47, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
											],
											v: [
												[59, 0],
												[-59, 0],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'st',
									c: { a: 0, k: [0.913725495338, 0.949019610882, 1, 1], ix: 3 },
									o: { a: 0, k: 100, ix: 4 },
									w: { a: 0, k: 1, ix: 5 },
									lc: 2,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Line 37',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Line 36',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 35, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
											],
											v: [
												[59, 0],
												[-59, 0],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'st',
									c: { a: 0, k: [0.913725495338, 0.949019610882, 1, 1], ix: 3 },
									o: { a: 0, k: 100, ix: 4 },
									w: { a: 0, k: 1, ix: 5 },
									lc: 2,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Line 36',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Line 35',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 23, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
											],
											v: [
												[59, 0],
												[-59, 0],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'st',
									c: { a: 0, k: [0.913725495338, 0.949019610882, 1, 1], ix: 3 },
									o: { a: 0, k: 100, ix: 4 },
									w: { a: 0, k: 1, ix: 5 },
									lc: 2,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Line 35',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 6,
					ty: 4,
					nm: 'Rectangle 379',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [103, 63.5, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 379',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 7,
					ty: 4,
					nm: 'Rectangle 378',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [83, 63.5, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 378',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 8,
					ty: 4,
					nm: 'Rectangle 377',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 63.5, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 377',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 9,
					ty: 4,
					nm: 'Rectangle 376',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [43, 63.5, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 376',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 10,
					ty: 4,
					nm: 'Rectangle 375',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [23, 63.5, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 375',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 11,
					ty: 4,
					nm: 'Rectangle 749',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 36, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, -2.209],
												[0, 0],
												[0, 0],
												[0, 0],
												[2.209, 0],
											],
											o: [
												[-2.209, 0],
												[0, 0],
												[0, 0],
												[0, 0],
												[0, -2.209],
												[0, 0],
											],
											v: [
												[-59, -36],
												[-63, -32],
												[-63, 36],
												[63, 36],
												[63, -32],
												[59, -36],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 749',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 12,
					ty: 4,
					nm: 'Bars card BG',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 36, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [126, 72], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 0, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Bars card BG',
							np: 1,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_6',
			nm: 'Links Card',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 0,
					nm: 'Links Animate',
					refId: 'comp_7',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [58.5, 50, 0], ix: 2, l: 2 },
						a: { a: 0, k: [54.5, 22, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					w: 109,
					h: 44,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 0,
					nm: 'Links card BG',
					refId: 'comp_8',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 38, 0], ix: 2, l: 2 },
						a: { a: 0, k: [63, 38, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					w: 126,
					h: 76,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_7',
			nm: 'Links Animate',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Rectangle 758',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.833], y: [0.833] },
									o: { x: [0.167], y: [0.167] },
									t: 460,
									s: [0],
								},
								{ t: 470, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [72, 28, 0], ix: 2, l: 2 },
						a: { a: 0, k: [-12, 0, 0], ix: 1, l: 2 },
						s: {
							a: 1,
							k: [
								{
									i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
									o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
									t: 460,
									s: [7.083, 100, 100],
								},
								{ t: 470, s: [100, 100, 100] },
							],
							ix: 6,
							l: 2,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [24, 1.909], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.04699999094, 0.399500161409, 0.893000006676, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 758',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Rectangle 757',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.833], y: [0.833] },
									o: { x: [0.167], y: [0.167] },
									t: 460,
									s: [0],
								},
								{ t: 470, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [12, 28, 0], ix: 2, l: 2 },
						a: { a: 0, k: [-8, 0, 0], ix: 1, l: 2 },
						s: {
							a: 1,
							k: [
								{
									i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
									o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
									t: 460,
									s: [8.75, 100, 100],
								},
								{ t: 470, s: [100, 100, 100] },
							],
							ix: 6,
							l: 2,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [16, 2.056], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.04699999094, 0.399500161409, 0.893000006676, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 757',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Rectangle 754',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.833], y: [0.833] },
									o: { x: [0.167], y: [0.167] },
									t: 455,
									s: [0],
								},
								{ t: 465, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [12, 16, 0], ix: 2, l: 2 },
						a: { a: 0, k: [-8, 0, 0], ix: 1, l: 2 },
						s: {
							a: 1,
							k: [
								{
									i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
									o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
									t: 455,
									s: [9.375, 100, 100],
								},
								{ t: 465, s: [100, 100, 100] },
							],
							ix: 6,
							l: 2,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [16, 2.056], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.04699999094, 0.399500161409, 0.893000006676, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 754',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Rectangle 761',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.833], y: [0.833] },
									o: { x: [0.167], y: [0.167] },
									t: 465,
									s: [0],
								},
								{ t: 475, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [12, 40, 0], ix: 2, l: 2 },
						a: { a: 0, k: [-32, 0, 0], ix: 1, l: 2 },
						s: {
							a: 1,
							k: [
								{
									i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
									o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
									t: 465,
									s: [5, 100, 100],
								},
								{ t: 475, s: [100, 100, 100] },
							],
							ix: 6,
							l: 2,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [64, 2.017], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.04699999094, 0.399500161409, 0.893000006676, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 761',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Rectangle 753',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.833], y: [0.833] },
									o: { x: [0.167], y: [0.167] },
									t: 450,
									s: [0],
								},
								{ t: 470, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [12.034, 4, 0], ix: 2, l: 2 },
						a: { a: 0, k: [-32, 0, 0], ix: 1, l: 2 },
						s: {
							a: 1,
							k: [
								{
									i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
									o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
									t: 450,
									s: [3.281, 100, 100],
								},
								{ t: 470, s: [100, 100, 100] },
							],
							ix: 6,
							l: 2,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [64, 2.017], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.04699999094, 0.399500161409, 0.893000006676, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 753',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 6,
					ty: 4,
					nm: 'Rectangle 756',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.833], y: [0.833] },
									o: { x: [0.167], y: [0.167] },
									t: 460,
									s: [0],
								},
								{
									i: { x: [0.833], y: [0.833] },
									o: { x: [0.167], y: [0.167] },
									t: 461,
									s: [0],
								},
								{ t: 470, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [30, 28, 0], ix: 2, l: 2 },
						a: { a: 0, k: [-20, 0, 0], ix: 1, l: 2 },
						s: {
							a: 1,
							k: [
								{
									i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
									o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
									t: 461,
									s: [3.25, 100, 100],
								},
								{ t: 470, s: [100, 99.751, 100] },
							],
							ix: 6,
							l: 2,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [40, 1.965], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 756',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 7,
					ty: 4,
					nm: 'Rectangle 755',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.833], y: [0.833] },
									o: { x: [0.167], y: [0.167] },
									t: 455,
									s: [0],
								},
								{ t: 465, s: [100] },
							],
							ix: 11,
						},
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [30, 16, 0], ix: 2, l: 2 },
						a: { a: 0, k: [-39, 0, 0], ix: 1, l: 2 },
						s: {
							a: 1,
							k: [
								{
									i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
									o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
									t: 455,
									s: [1.538, 100, 100],
								},
								{ t: 465, s: [100, 100, 100] },
							],
							ix: 6,
							l: 2,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [78, 1.974], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 755',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 8,
					ty: 4,
					nm: 'Ellipse 10',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [4, 28, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [8, 8], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 1,
										k: [
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 460,
												s: [0.878431379795, 0.878431379795, 0.878431379795, 1],
											},
											{
												t: 470,
												s: [0.874509811401, 0.847058832645, 0.992156863213, 1],
											},
										],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 10',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 9,
					ty: 4,
					nm: 'Ellipse 9',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [4, 16, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [8, 8], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 1,
										k: [
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 455,
												s: [0.878431379795, 0.878431379795, 0.878431379795, 1],
											},
											{
												t: 465,
												s: [0.874400138855, 0.848000109196, 0.991999924183, 1],
											},
										],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 9',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 10,
					ty: 4,
					nm: 'Ellipse 11',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [4, 40, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [8, 8], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 1,
										k: [
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 465,
												s: [0.878431379795, 0.878431379795, 0.878431379795, 1],
											},
											{ t: 475, s: [0.800000011921, 0.878431379795, 1, 1] },
										],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 11',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 11,
					ty: 4,
					nm: 'Ellipse 8',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [4, 4, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [8, 8], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 1,
										k: [
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 450,
												s: [0.879549622536, 0.879549622536, 0.879549622536, 1],
											},
											{
												t: 460,
												s: [0.729411780834, 0.952941179276, 0.858823537827, 1],
											},
										],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 12,
					ty: 4,
					nm: 'Links Animate',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [54.5, 22, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [108.999, 44], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 0, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Links Animate',
							np: 1,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_8',
			nm: 'Links card BG',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Rectangle 752',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [13, 23, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [18, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 752',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Rectangle 754',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [49, 14, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [90, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 754',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Rectangle 751',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [14, 7, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [20, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.800000011921, 0.878431379795, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 751',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Rectangle 749',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 38, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [126, 76], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 4, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 749',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Links card BG',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 38, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [126, 76], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 0, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Links card BG',
							np: 1,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_9',
			nm: 'Graph Card',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 0,
					nm: 'Graph legend Animate',
					refId: 'comp_10',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [90, 41, 0], ix: 2, l: 2 },
						a: { a: 0, k: [20, 18, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					hasMask: true,
					masksProperties: [
						{
							inv: false,
							mode: 'a',
							pt: {
								a: 1,
								k: [
									{
										i: { x: 0.833, y: 0.833 },
										o: { x: 0.167, y: 0.167 },
										t: 429,
										s: [
											{
												i: [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0],
												],
												o: [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0],
												],
												v: [
													[-3.625, 0],
													[-3.625, 36],
													[-0.75, 36],
													[-0.75, 0],
												],
												c: true,
											},
										],
									},
									{
										t: 439,
										s: [
											{
												i: [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0],
												],
												o: [
													[0, 0],
													[0, 0],
													[0, 0],
													[0, 0],
												],
												v: [
													[0, 0],
													[0, 36],
													[41, 36],
													[41, 0],
												],
												c: true,
											},
										],
									},
								],
								ix: 1,
							},
							o: { a: 0, k: 100, ix: 3 },
							x: { a: 0, k: 0, ix: 4 },
							nm: 'Mask 1',
						},
					],
					w: 40,
					h: 36,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 0,
					nm: 'Pie Chart Animate',
					refId: 'comp_11',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: { x: [0.833], y: [0.833] },
									o: { x: [0.167], y: [0.167] },
									t: 430,
									s: [0],
								},
								{ t: 445, s: [100] },
							],
							ix: 11,
						},
						r: {
							a: 1,
							k: [
								{
									i: { x: [0.128], y: [0.998] },
									o: { x: [0.167], y: [0.167] },
									t: 430,
									s: [0],
								},
								{
									i: { x: [0.833], y: [0.833] },
									o: { x: [0.333], y: [0] },
									t: 460,
									s: [380.16],
								},
								{ t: 474, s: [360] },
							],
							ix: 10,
						},
						p: { a: 0, k: [40, 41, 0], ix: 2, l: 2 },
						a: { a: 0, k: [24, 24, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					w: 48,
					h: 48,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 0,
					nm: 'Graph card BG',
					refId: 'comp_12',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 38, 0], ix: 2, l: 2 },
						a: { a: 0, k: [63, 38, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					w: 126,
					h: 76,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_10',
			nm: 'Graph legend Animate',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Rectangle 756',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [23, 34, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [34, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 756',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Rectangle 755',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [23, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [34, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 755',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Rectangle 754',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [23, 18, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [34, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 754',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Rectangle 753',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [23, 10, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [34, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 753',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Rectangle 752',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [23, 2, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [34, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 752',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 6,
					ty: 4,
					nm: 'Rectangle 369',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [2, 34, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 369',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 7,
					ty: 4,
					nm: 'Rectangle 368',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [2, 2, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.340000033379, 0.615000128746, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 368',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 8,
					ty: 4,
					nm: 'Rectangle 367',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [2, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.960784316063, 0.803921580315, 0.278431385756, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 367',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 9,
					ty: 4,
					nm: 'Rectangle 366',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [2, 10, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.972549021244, 0.443137258291, 0.407843142748, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 366',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 10,
					ty: 4,
					nm: 'Rectangle 365',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [2, 18, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.29411765933, 0.807843148708, 0.592156887054, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 365',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 11,
					ty: 4,
					nm: 'Graph legend Animate',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [20, 18, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [40, 36], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 0, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Graph legend Animate',
							np: 1,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_11',
			nm: 'Pie Chart Animate',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Subtract',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [20.5, 36.025, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 6.37],
												[0, 0],
												[-7.417, 0],
												[-2.432, 2.432],
												[0, 0],
												[6.369, 0],
												[4.504, 4.504],
											],
											o: [
												[0, 0],
												[0.009, 7.415],
												[3.711, 0],
												[0, 0],
												[-4.504, 4.504],
												[-6.369, 0],
												[-4.504, -4.504],
											],
											v: [
												[-20.5, -12.008],
												[-9.94, -12.008],
												[3.5, 1.415],
												[13.004, -2.521],
												[20.5, 4.974],
												[3.517, 12.008],
												[-13.465, 4.974],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.340000033379, 0.615000128746, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Subtract',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Subtract',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [40.769, 24.017, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[4.504, 4.504],
												[0, 0],
												[0, -3.703],
												[2.432, -2.432],
												[0, 0],
												[0, 6.37],
											],
											o: [
												[0, 0],
												[2.423, 2.431],
												[0, 3.711],
												[0, 0],
												[4.504, -4.504],
												[0, -6.37],
											],
											v: [
												[0.23, -16.982],
												[-7.249, -9.503],
												[-3.328, -0.016],
												[-7.265, 9.487],
												[0.23, 16.982],
												[7.265, 0],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.972549021244, 0.443137258291, 0.407843142748, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Subtract',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Subtract',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [32.508, 7.257, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[3.713, 0.004],
												[0, 0],
												[-4.504, -4.504],
											],
											o: [
												[-2.43, -2.438],
												[0, 0],
												[6.37, 0],
												[0, 0],
											],
											v: [
												[1.012, 7.257],
												[-8.491, 3.304],
												[-8.491, -7.257],
												[8.491, -0.222],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.29411765933, 0.807843148708, 0.592156887054, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Subtract',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Subtract',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [12.009, 12.009, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, -3.712],
												[0, -0.005],
												[0, 0],
												[-4.504, 4.504],
												[-6.37, 0],
												[0, 0],
												[0.006, 0],
												[2.432, -2.432],
											],
											o: [
												[0, 0.005],
												[0, 0],
												[0, -6.37],
												[4.504, -4.504],
												[0, 0],
												[-0.006, 0],
												[-3.711, 0],
												[-2.432, 2.432],
											],
											v: [
												[-1.449, 11.992],
												[-1.449, 12.008],
												[-12.009, 12.008],
												[-4.974, -4.974],
												[12.009, -12.008],
												[12.009, -1.448],
												[11.991, -1.448],
												[2.488, 2.488],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.701960802078, 0.729411780834, 0.772549033165, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Subtract',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Pie Chart Animate',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [24, 24, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [48, 48], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 0, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Pie Chart Animate',
							np: 1,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_12',
			nm: 'Graph card BG',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Rectangle 751',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [14, 7, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [20, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.800000011921, 0.878431379795, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 751',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Rectangle 749',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 38, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [126, 76], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 4, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 749',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Graph card BG',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [63, 38, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [126, 76], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 0, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Graph card BG',
							np: 1,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_13',
			nm: 'Summary title cards',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 0,
					nm: 'Card 4',
					refId: 'comp_14',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [225.5, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [30.5, 12, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					w: 61,
					h: 24,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 0,
					nm: 'Card 2',
					refId: 'comp_15',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [95.5, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [30.5, 12, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					w: 61,
					h: 24,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 0,
					nm: 'Card 3',
					refId: 'comp_16',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [160.5, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [30.5, 12, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					w: 61,
					h: 24,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 0,
					nm: 'Card 1',
					refId: 'comp_17',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [30.5, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [30.5, 12, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					w: 61,
					h: 24,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_14',
			nm: 'Card 4',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Rectangle 750',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [32, 15, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [28, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 750',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Rectangle 9',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [28, 10, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [20, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.800000011921, 0.878431379795, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 9',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Ellipse 7',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [10, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [12, 12], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.996078431606, 0.870588243008, 0.784313738346, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 7',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Rectangle 748',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [30.5, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [61, 24], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 4, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 748',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Card 4',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [30.5, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [61, 24], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 0, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Card 4',
							np: 1,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_15',
			nm: 'Card 2',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Rectangle 750',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [32, 15, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [28, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 750',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Rectangle 9',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [28, 10, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [20, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.800000011921, 0.878431379795, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 9',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Ellipse 7',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [10, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [12, 12], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.776470601559, 0.929411768913, 0.984313726425, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 7',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Rectangle 748',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [30.5, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [61, 24], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 4, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 748',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Card 2',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [30.5, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [61, 24], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 0, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Card 2',
							np: 1,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_16',
			nm: 'Card 3',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Rectangle 750',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [32, 15, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [28, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 750',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Rectangle 9',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [28, 10, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [20, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.800000011921, 0.878431379795, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 9',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Ellipse 7',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [10, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [12, 12], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.874400138855, 0.848000109196, 0.991999924183, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 7',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Rectangle 748',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [30.5, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [61, 24], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 4, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 748',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Card 3',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [30.5, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [61, 24], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 0, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Card 3',
							np: 1,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_17',
			nm: 'Card 1',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Rectangle 750',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [32, 15, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [28, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 750',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Rectangle 9',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [28, 10, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [20, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.800000011921, 0.878431379795, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 9',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Ellipse 7',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [10, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [12, 12], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.729411780834, 0.952941179276, 0.858823537827, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 7',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Rectangle 748',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [30.5, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [61, 24], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 4, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 748',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Card 1',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [30.5, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [61, 24], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 0, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Card 1',
							np: 1,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_18',
			nm: 'Release',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Release',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [19, 3, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [38, 6], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 2, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 1,
										k: [
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 330,
												s: [0.972549021244, 0.443137258291, 0.407843142748, 1],
											},
											{
												t: 340,
												s: [0.29411765933, 0.807843148708, 0.592156887054, 1],
											},
										],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Release',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_19',
			nm: 'Calendar',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Rectangle 757',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [171, 49, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [122, 6], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 2, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.29411765933, 0.807843148708, 0.592156887054, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 757',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Rectangle 755',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [87, 109, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [38, 6], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 2, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.294117647059, 0.807843137255, 0.592156862745, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 755',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Line 11',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [128, 134.662, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
											],
											v: [
												[-128, 0],
												[128, 0],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'st',
									c: { a: 0, k: [0.8, 0.878431372549, 1, 1], ix: 3 },
									o: { a: 0, k: 100, ix: 4 },
									w: { a: 0, k: 1, ix: 5 },
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Line 11',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Line 10',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [128, 104.287, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
											],
											v: [
												[-128, 0],
												[128, 0],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'st',
									c: { a: 0, k: [0.8, 0.878431372549, 1, 1], ix: 3 },
									o: { a: 0, k: 100, ix: 4 },
									w: { a: 0, k: 1, ix: 5 },
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Line 10',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Line 9',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [128, 73.912, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
											],
											v: [
												[-128, 0],
												[128, 0],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'st',
									c: { a: 0, k: [0.8, 0.878431372549, 1, 1], ix: 3 },
									o: { a: 0, k: 100, ix: 4 },
									w: { a: 0, k: 1, ix: 5 },
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Line 9',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 6,
					ty: 4,
					nm: 'Line 8',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [128, 43.537, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
											],
											v: [
												[-128, 0],
												[128, 0],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'st',
									c: { a: 0, k: [0.8, 0.878431372549, 1, 1], ix: 3 },
									o: { a: 0, k: 100, ix: 4 },
									w: { a: 0, k: 1, ix: 5 },
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Line 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 7,
					ty: 4,
					nm: 'Line 7',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [128, 13.162, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
											],
											v: [
												[-128, 0],
												[128, 0],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'st',
									c: { a: 0, k: [0.8, 0.878431372549, 1, 1], ix: 3 },
									o: { a: 0, k: 100, ix: 4 },
									w: { a: 0, k: 1, ix: 5 },
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Line 7',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 8,
					ty: 4,
					nm: 'Line 6',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [233.473, 81, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [-100, -100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
											],
											v: [
												[-81, 0],
												[81, 0],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'st',
									c: { a: 0, k: [0.8, 0.878431372549, 1, 1], ix: 3 },
									o: { a: 0, k: 100, ix: 4 },
									w: { a: 0, k: 1, ix: 5 },
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: -90, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Line 6',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 9,
					ty: 4,
					nm: 'Line 5',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [191.488, 81, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [-100, -100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
											],
											v: [
												[-81, 0],
												[81, 0],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'st',
									c: { a: 0, k: [0.8, 0.878431372549, 1, 1], ix: 3 },
									o: { a: 0, k: 100, ix: 4 },
									w: { a: 0, k: 1, ix: 5 },
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: -90, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Line 5',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 10,
					ty: 4,
					nm: 'Line 4',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [149.504, 81, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [-100, -100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
											],
											v: [
												[-81, 0],
												[81, 0],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'st',
									c: { a: 0, k: [0.8, 0.878431372549, 1, 1], ix: 3 },
									o: { a: 0, k: 100, ix: 4 },
									w: { a: 0, k: 1, ix: 5 },
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: -90, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Line 4',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 11,
					ty: 4,
					nm: 'Line 3',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [107.52, 81, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [-100, -100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
											],
											v: [
												[-81, 0],
												[81, 0],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'st',
									c: { a: 0, k: [0.8, 0.878431372549, 1, 1], ix: 3 },
									o: { a: 0, k: 100, ix: 4 },
									w: { a: 0, k: 1, ix: 5 },
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: -90, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Line 3',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 12,
					ty: 4,
					nm: 'Line 2',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [65.535, 81, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [-100, -100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
											],
											v: [
												[-81, 0],
												[81, 0],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'st',
									c: { a: 0, k: [0.8, 0.878431372549, 1, 1], ix: 3 },
									o: { a: 0, k: 100, ix: 4 },
									w: { a: 0, k: 1, ix: 5 },
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: -90, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Line 2',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 13,
					ty: 4,
					nm: 'Line 1',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [23.551, 81, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [-100, -100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
											],
											v: [
												[-81, 0],
												[81, 0],
											],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'st',
									c: { a: 0, k: [0.8, 0.878431372549, 1, 1], ix: 3 },
									o: { a: 0, k: 100, ix: 4 },
									w: { a: 0, k: 1, ix: 5 },
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: -90, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Line 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 14,
					ty: 4,
					nm: 'Rectangle 4388',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [245, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4388',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 15,
					ty: 4,
					nm: 'Rectangle 4387',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [213, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4387',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 16,
					ty: 4,
					nm: 'Rectangle 4386',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [171, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4386',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 17,
					ty: 4,
					nm: 'Rectangle 4385',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [129, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4385',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 18,
					ty: 4,
					nm: 'Rectangle 4384',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [87, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4384',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 19,
					ty: 4,
					nm: 'Rectangle 4383',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [45, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4383',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 20,
					ty: 4,
					nm: 'Rectangle 8',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [12, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 21,
					ty: 4,
					nm: 'Rectangle 4382',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [128, 81, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [256, 162], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 3, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4382',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_20',
			nm: 'Card',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Rectangle 8',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [6, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Ellipse 1',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [43, 25, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [6, 6], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Rectangle 11',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [14, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [8, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 11',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Rectangle 10',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [16, 9, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [24, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 10',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Rectangle 6',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 5, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [42, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 6',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 6,
					ty: 4,
					nm: 'Rectangle 4383',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 16, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [50, 32], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 2, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4383',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_21',
			nm: 'Boards',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 3,
					nm: '▽ Group 581',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [227, 105, 0], ix: 2, l: 2 },
						a: { a: 0, k: [25, 16, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Rectangle 8',
					parent: 1,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [6, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Ellipse 1',
					parent: 1,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [43, 25, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [6, 6], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Rectangle 11',
					parent: 1,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [14, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [8, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 11',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Rectangle 10',
					parent: 1,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [16, 9, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [24, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 10',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 6,
					ty: 4,
					nm: 'Rectangle 6',
					parent: 1,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 5, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [42, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 6',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 7,
					ty: 4,
					nm: 'Rectangle 4383',
					parent: 1,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 16, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [50, 32], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 2, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4383',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 8,
					ty: 3,
					nm: '▽ Group 580',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [227, 69, 0], ix: 2, l: 2 },
						a: { a: 0, k: [25, 16, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 9,
					ty: 4,
					nm: 'Rectangle 8',
					parent: 8,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [6, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 10,
					ty: 4,
					nm: 'Ellipse 1',
					parent: 8,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [43, 25, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [6, 6], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 11,
					ty: 4,
					nm: 'Rectangle 11',
					parent: 8,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [14, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [8, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 11',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 12,
					ty: 4,
					nm: 'Rectangle 10',
					parent: 8,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [16, 9, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [24, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 10',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 13,
					ty: 4,
					nm: 'Rectangle 6',
					parent: 8,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 5, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [42, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 6',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 14,
					ty: 4,
					nm: 'Rectangle 4383',
					parent: 8,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 16, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [50, 32], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 2, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4383',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 15,
					ty: 3,
					nm: '▽ Group 574',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [95, 69, 0], ix: 2, l: 2 },
						a: { a: 0, k: [25, 16, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 16,
					ty: 4,
					nm: 'Rectangle 8',
					parent: 15,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [6, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 17,
					ty: 4,
					nm: 'Ellipse 1',
					parent: 15,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [43, 25, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [6, 6], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 18,
					ty: 4,
					nm: 'Rectangle 11',
					parent: 15,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [14, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [8, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 11',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 19,
					ty: 4,
					nm: 'Rectangle 10',
					parent: 15,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [16, 9, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [24, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 10',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 20,
					ty: 4,
					nm: 'Rectangle 6',
					parent: 15,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 5, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [42, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 6',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 21,
					ty: 4,
					nm: 'Rectangle 4383',
					parent: 15,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 16, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [50, 32], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 2, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4383',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 22,
					ty: 3,
					nm: '▽ Group 571',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [29, 69, 0], ix: 2, l: 2 },
						a: { a: 0, k: [25, 16, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 23,
					ty: 4,
					nm: 'Rectangle 8',
					parent: 22,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [6, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 24,
					ty: 4,
					nm: 'Ellipse 1',
					parent: 22,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [43, 25, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [6, 6], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 25,
					ty: 4,
					nm: 'Rectangle 11',
					parent: 22,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [14, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [8, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 11',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 26,
					ty: 4,
					nm: 'Rectangle 10',
					parent: 22,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [16, 9, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [24, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 10',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 27,
					ty: 4,
					nm: 'Rectangle 6',
					parent: 22,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 5, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [42, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 6',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 28,
					ty: 4,
					nm: 'Rectangle 4383',
					parent: 22,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 16, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [50, 32], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 2, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4383',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 29,
					ty: 3,
					nm: '▽ Group 579',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [227, 33, 0], ix: 2, l: 2 },
						a: { a: 0, k: [25, 16, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 30,
					ty: 4,
					nm: 'Rectangle 8',
					parent: 29,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [6, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 31,
					ty: 4,
					nm: 'Ellipse 1',
					parent: 29,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [43, 25, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [6, 6], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 32,
					ty: 4,
					nm: 'Rectangle 11',
					parent: 29,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [14, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [8, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 6, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 11',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 33,
					ty: 4,
					nm: 'Rectangle 10',
					parent: 29,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [16, 9, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [24, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 10',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 34,
					ty: 4,
					nm: 'Rectangle 6',
					parent: 29,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 5, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [42, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 6',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 35,
					ty: 4,
					nm: 'Rectangle 4383',
					parent: 29,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 16, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [50, 32], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 2, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4383',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 36,
					ty: 3,
					nm: '▽ Group 576',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [161, 33, 0], ix: 2, l: 2 },
						a: { a: 0, k: [25, 16, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 37,
					ty: 4,
					nm: 'Rectangle 8',
					parent: 36,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [6, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 38,
					ty: 4,
					nm: 'Ellipse 1',
					parent: 36,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [43, 25, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [6, 6], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 39,
					ty: 4,
					nm: 'Rectangle 11',
					parent: 36,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [14, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [8, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 11',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 40,
					ty: 4,
					nm: 'Rectangle 10',
					parent: 36,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [16, 9, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [24, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 10',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 41,
					ty: 4,
					nm: 'Rectangle 6',
					parent: 36,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 5, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [42, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 6',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 42,
					ty: 4,
					nm: 'Rectangle 4383',
					parent: 36,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 16, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [50, 32], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 2, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4383',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 43,
					ty: 3,
					nm: '▽ Group 573',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [95, 33, 0], ix: 2, l: 2 },
						a: { a: 0, k: [25, 16, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 44,
					ty: 4,
					nm: 'Rectangle 8',
					parent: 43,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [6, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 45,
					ty: 4,
					nm: 'Ellipse 1',
					parent: 43,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [43, 25, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [6, 6], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 46,
					ty: 4,
					nm: 'Rectangle 11',
					parent: 43,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [14, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [8, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 11',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 47,
					ty: 4,
					nm: 'Rectangle 10',
					parent: 43,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [16, 9, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [24, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 10',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 48,
					ty: 4,
					nm: 'Rectangle 6',
					parent: 43,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 5, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [42, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 6',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 49,
					ty: 4,
					nm: 'Rectangle 4383',
					parent: 43,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 16, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [50, 32], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 2, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4383',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 50,
					ty: 3,
					nm: '▽ Group 570',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [29, 33, 0], ix: 2, l: 2 },
						a: { a: 0, k: [25, 16, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 51,
					ty: 4,
					nm: 'Rectangle 8',
					parent: 50,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [6, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [4, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 1, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 52,
					ty: 4,
					nm: 'Ellipse 1',
					parent: 50,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [43, 25, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: { a: 0, k: [6, 6], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 53,
					ty: 4,
					nm: 'Rectangle 11',
					parent: 50,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [14, 26, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [8, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 11',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 54,
					ty: 4,
					nm: 'Rectangle 10',
					parent: 50,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [16, 9, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [24, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 10',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 55,
					ty: 4,
					nm: 'Rectangle 6',
					parent: 50,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 5, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [42, 2], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.799999952316, 0.879999995232, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 6',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 56,
					ty: 4,
					nm: 'Rectangle 4383',
					parent: 50,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [25, 16, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [50, 32], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 2, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4383',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 57,
					ty: 4,
					nm: 'Rectangle 4388',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [207.6, 7, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4388',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 58,
					ty: 4,
					nm: 'Rectangle 4386',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [141.6, 7, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4386',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 59,
					ty: 4,
					nm: 'Rectangle 4384',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [75.6, 7, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4384',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 60,
					ty: 4,
					nm: 'Rectangle 8',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [9.6, 7, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 61,
					ty: 4,
					nm: 'Rectangle 4387',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [227, 83, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [58, 162], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 3, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 1,
										k: [
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 60,
												s: [0.799999952316, 0.879999995232, 1, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 70,
												s: [0.394944012165, 0.542983591557, 0.765042901039, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 150,
												s: [0.394944012165, 0.542983591557, 0.765042901039, 1],
											},
											{ t: 160, s: [0.800000071526, 0.8784314394, 1, 1] },
										],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4387',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 62,
					ty: 4,
					nm: 'Rectangle 4385',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [161, 83, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [58, 162], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 3, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 1,
										k: [
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 60,
												s: [0.800000071526, 0.8784314394, 1, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 70,
												s: [0.396078467369, 0.541176497936, 0.764705955982, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 150,
												s: [0.396078467369, 0.541176497936, 0.764705955982, 1],
											},
											{ t: 160, s: [0.800000071526, 0.8784314394, 1, 1] },
										],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4385',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 63,
					ty: 4,
					nm: 'Rectangle 4383',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [95, 83, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [58, 162], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 3, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 1,
										k: [
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 60,
												s: [0.799999952316, 0.879999995232, 1, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 70,
												s: [0.396078467369, 0.541176497936, 0.764705955982, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 113,
												s: [0.396078467369, 0.541176497936, 0.764705955982, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 123,
												s: [0.932567417622, 0.95895409584, 1, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 150,
												s: [0.933333337307, 0.960784316063, 1, 1],
											},
											{ t: 160, s: [0.800000071526, 0.8784314394, 1, 1] },
										],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0.107, 0.263], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4383',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 64,
					ty: 4,
					nm: 'Rectangle 4382',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [29, 83, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [58, 162], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 3, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 1,
										k: [
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 60,
												s: [0.799999952316, 0.879999995232, 1, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 70,
												s: [0.933333337307, 0.960784316063, 1, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 91,
												s: [0.933333337307, 0.960784316063, 1, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 113,
												s: [0.933333337307, 0.960784316063, 1, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 123,
												s: [0.396078467369, 0.541176497936, 0.764705955982, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 150,
												s: [0.396078467369, 0.541176497936, 0.764705955982, 1],
											},
											{ t: 160, s: [0.800000071526, 0.8784314394, 1, 1] },
										],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4382',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_22',
			nm: 'Tabs',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Rectangle 4390',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [106, 2, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [20, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.035294119269, 0.117647059262, 0.258823543787, 0.310000002384],
										ix: 4,
									},
									o: { a: 0, k: 31, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4390',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Rectangle 4389',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [82, 2, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [20, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.035294117647, 0.117647058824, 0.258823529412, 1],
										ix: 4,
									},
									o: { a: 0, k: 31, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4389',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Rectangle 10',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [58, 2, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [20, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 1,
										k: [
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 220,
												s: [0.035294117647, 0.117647058824, 0.258823529412, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 230,
												s: [1, 1, 1, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 400,
												s: [1, 1, 1, 1],
											},
											{
												t: 410,
												s: [0.035294119269, 0.117647059262, 0.258823543787, 1],
											},
										],
										ix: 4,
									},
									o: {
										a: 1,
										k: [
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 220,
												s: [31],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 230,
												s: [100],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 400,
												s: [100],
											},
											{ t: 410, s: [31] },
										],
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 10',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Rectangle 9',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [34, 2, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [20, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 6, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 1,
										k: [
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 220,
												s: [1, 1, 1, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 230,
												s: [0.035294119269, 0.117647059262, 0.258823543787, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 600,
												s: [0.035294119269, 0.117647059262, 0.258823543787, 1],
											},
											{ t: 610, s: [1, 1, 1, 1] },
										],
										ix: 4,
									},
									o: {
										a: 1,
										k: [
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 220,
												s: [100],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 230,
												s: [31],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 600,
												s: [31],
											},
											{ t: 610, s: [100] },
										],
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 9',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'Rectangle 8',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [10, 2, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [20, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 16, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 1,
										k: [
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 400,
												s: [0.035294119269, 0.117647059262, 0.258823543787, 0.310000002384],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 410,
												s: [1, 1, 1, 1],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 600,
												s: [1, 1, 1, 1],
											},
											{
												t: 610,
												s: [0.035294119269, 0.117647059262, 0.258823543787, 1],
											},
										],
										ix: 4,
									},
									o: {
										a: 1,
										k: [
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 400,
												s: [31],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 410,
												s: [100],
											},
											{
												i: { x: [0.833], y: [0.833] },
												o: { x: [0.167], y: [0.167] },
												t: 600,
												s: [100],
											},
											{ t: 610, s: [31] },
										],
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_23',
			nm: 'Screen',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 5,
					nm: 'Business project',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [88, 15, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					t: {
						d: {
							k: [
								{
									s: {
										sz: [162, 14],
										ps: [-81, -7],
										s: 10,
										f: 'Helvetica',
										t: 'Business project',
										ca: 0,
										j: 0,
										tr: 0,
										lh: 1.1875,
										ls: 0,
										fc: [0.09, 0.169, 0.302],
									},
									t: 0,
								},
							],
						},
						p: {},
						m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
						a: [],
					},
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Rectangle 2',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [180, 12, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, -2.209],
												[0, 0],
												[0, 0],
												[0, 0],
												[2.209, 0],
											],
											o: [
												[-2.209, 0],
												[0, 0],
												[0, 0],
												[0, 0],
												[0, -2.209],
												[0, 0],
											],
											v: [
												[-176, -12],
												[-180, -8],
												[-180, 12],
												[180, 12],
												[180, -8],
												[176, -12],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 2',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 3,
					nm: '▽ Group 587',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [37, 140, 0], ix: 2, l: 2 },
						a: { a: 0, k: [37, 116, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 6,
					ty: 3,
					nm: '▽ Group 586',
					parent: 5,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [37, 85, 0], ix: 2, l: 2 },
						a: { a: 0, k: [29, 72, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 7,
					ty: 3,
					nm: '▽ Group 569',
					parent: 6,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [29, 138, 0], ix: 2, l: 2 },
						a: { a: 0, k: [29, 6, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 8,
					ty: 4,
					nm: 'Rectangle 20',
					parent: 7,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [38, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [40, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 9,
					ty: 4,
					nm: 'Rectangle 19',
					parent: 7,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [6, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 12], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 4, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.874400138855, 0.848000109196, 0.991999924183, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 7',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 10,
					ty: 3,
					nm: '▽ Group 567',
					parent: 6,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [29, 118, 0], ix: 2, l: 2 },
						a: { a: 0, k: [29, 6, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 11,
					ty: 4,
					nm: 'Rectangle 18',
					parent: 10,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [38, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [40, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 12,
					ty: 4,
					nm: 'Rectangle 17',
					parent: 10,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [6, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 12], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 4, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.996078431606, 0.870588243008, 0.784313738346, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 7',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 13,
					ty: 3,
					nm: '▽ Group 566',
					parent: 6,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [29, 98, 0], ix: 2, l: 2 },
						a: { a: 0, k: [29, 6, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 14,
					ty: 4,
					nm: 'Rectangle 16',
					parent: 13,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [38, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [40, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 15,
					ty: 4,
					nm: 'Rectangle 15',
					parent: 13,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [6, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 12], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 4, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.776470601559, 0.929411768913, 0.984313726425, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 7',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 16,
					ty: 3,
					nm: '▽ Group 565',
					parent: 6,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [29, 78, 0], ix: 2, l: 2 },
						a: { a: 0, k: [29, 6, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 17,
					ty: 4,
					nm: 'Rectangle 14',
					parent: 16,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [38, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [40, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 18,
					ty: 4,
					nm: 'Rectangle 13',
					parent: 16,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [6, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 12], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 4, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.874400138855, 0.848000109196, 0.991999924183, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 7',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 19,
					ty: 3,
					nm: '▽ Group 564',
					parent: 6,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [29, 58, 0], ix: 2, l: 2 },
						a: { a: 0, k: [29, 6, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 20,
					ty: 4,
					nm: 'Rectangle 12',
					parent: 19,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [38, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [40, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 21,
					ty: 4,
					nm: 'Rectangle 11',
					parent: 19,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [6, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 12], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 4, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.035294119269, 0.117647059262, 0.258823543787, 0.039999999106],
										ix: 3,
									},
									o: { a: 0, k: 4, ix: 4 },
									w: { a: 0, k: 0.714, ix: 5 },
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.340000033379, 0.615000128746, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 7',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 22,
					ty: 4,
					nm: 'Rectangle 10',
					parent: 6,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [16, 42, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [32, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 23,
					ty: 3,
					nm: '▽ Group 568',
					parent: 6,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [29, 18, 0], ix: 2, l: 2 },
						a: { a: 0, k: [29, 6, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 24,
					ty: 4,
					nm: 'Rectangle 9',
					parent: 23,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [38, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [40, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [0.519999980927, 0.720000088215, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 25,
					ty: 4,
					nm: 'Rectangle 7',
					parent: 23,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [6, 6, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [12, 12], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 4, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.874400138855, 0.848000109196, 0.991999924183, 1],
										ix: 4,
									},
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 7',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 26,
					ty: 4,
					nm: 'Rectangle 6',
					parent: 6,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [16, 2, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [32, 4], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 8, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'fl',
									c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
									o: { a: 0, k: 100, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 6',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 27,
					ty: 4,
					nm: 'Rectangle 8',
					parent: 5,
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [37, 116, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
												[0, 0],
												[-2.209, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 2.209],
												[0, 0],
												[0, 0],
											],
											v: [
												[37, -116],
												[-37, -116],
												[-37, 112],
												[-33, 116],
												[37, 116],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.035294119269, 0.117647059262, 0.258823543787, 0.310000002384],
										ix: 4,
									},
									o: { a: 0, k: 31, ix: 5 },
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 8',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 28,
					ty: 4,
					nm: 'Rectangle 1',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [180, 140, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
												[0, 0],
												[-2.209, 0],
												[0, 0],
												[0, 2.209],
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 2.209],
												[0, 0],
												[2.209, 0],
												[0, 0],
											],
											v: [
												[180, -116],
												[-180, -116],
												[-180, 112],
												[-176, 116],
												[176, 116],
												[180, 112],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'gf',
									o: { a: 0, k: 100, ix: 10 },
									r: 1,
									bm: 0,
									g: {
										p: 3,
										k: {
											a: 0,
											k: [0, 0.047, 0.4, 0.894, 0.5, 0.041, 0.298, 0.659, 1, 0.035, 0.196, 0.424],
											ix: 9,
										},
									},
									s: { a: 0, k: [-180, -116], ix: 5 },
									e: { a: 0, k: [180, 116], ix: 6 },
									t: 1,
									nm: 'Gradient Fill 1',
									mn: 'ADBE Vector Graphic - G-Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_24',
			nm: 'Background',
			fr: 60,
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Background',
					sr: 1,
					ks: {
						o: { a: 0, k: 100, ix: 11 },
						r: { a: 0, k: 0, ix: 10 },
						p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
						a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
						s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: { a: 0, k: [400, 400], ix: 2 },
									p: { a: 0, k: [0, 0], ix: 3 },
									r: { a: 0, k: 0, ix: 4 },
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'gf',
									o: { a: 0, k: 100, ix: 10 },
									r: 1,
									bm: 0,
									g: {
										p: 3,
										k: {
											a: 0,
											k: [0, 0.52, 0.72, 1, 0.5, 0.76, 0.821, 0.951, 1, 1, 0.922, 0.902],
											ix: 9,
										},
									},
									s: { a: 0, k: [94.938, 200.196], ix: 5 },
									e: { a: 0, k: [-33.328, -186.761], ix: 6 },
									t: 1,
									nm: 'Gradient Fill 1',
									mn: 'ADBE Vector Graphic - G-Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: { a: 0, k: [0, 0], ix: 2 },
									a: { a: 0, k: [0, 0], ix: 1 },
									s: { a: 0, k: [100, 100], ix: 3 },
									r: { a: 0, k: 0, ix: 6 },
									o: { a: 0, k: 100, ix: 7 },
									sk: { a: 0, k: 0, ix: 4 },
									sa: { a: 0, k: 0, ix: 5 },
									nm: 'Transform',
								},
							],
							nm: 'Background',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 720,
					st: 0,
					ct: 1,
					bm: 0,
				},
			],
		},
	],
	fonts: {
		list: [
			{ fName: 'Helvetica', fFamily: 'Helvetica', fStyle: 'Regular', ascent: 71.8994140625 },
			{
				fName: 'Helvetica-Bold',
				fFamily: 'Helvetica',
				fStyle: 'Bold',
				ascent: 71.8536376953125,
			},
		],
	},
	layers: [
		{
			ddd: 0,
			ind: 1,
			ty: 0,
			nm: 'Progress Card',
			refId: 'comp_0',
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 400,
							s: [0],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 410,
							s: [100],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 600,
							s: [100],
						},
						{ t: 610, s: [0] },
					],
					ix: 11,
				},
				r: { a: 0, k: 0, ix: 10 },
				p: {
					a: 1,
					k: [
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 400,
							s: [268, 256, 0],
							to: [-5, 0, 0],
							ti: [5, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 410,
							s: [238, 256, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 600,
							s: [238, 256, 0],
							to: [-5, 0, 0],
							ti: [5, 0, 0],
						},
						{ t: 610, s: [208, 256, 0] },
					],
					ix: 2,
					l: 2,
				},
				a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
				s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
			},
			ao: 0,
			w: 126,
			h: 72,
			ip: 400,
			op: 720,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 2,
			ty: 0,
			nm: 'Bars Card',
			refId: 'comp_3',
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 400,
							s: [0],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 410,
							s: [100],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 600,
							s: [100],
						},
						{ t: 610, s: [0] },
					],
					ix: 11,
				},
				r: { a: 0, k: 0, ix: 10 },
				p: {
					a: 1,
					k: [
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 400,
							s: [138, 256, 0],
							to: [-5, 0, 0],
							ti: [5, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 410,
							s: [108, 256, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 600,
							s: [108, 256, 0],
							to: [-5, 0, 0],
							ti: [5, 0, 0],
						},
						{ t: 610, s: [78, 256, 0] },
					],
					ix: 2,
					l: 2,
				},
				a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
				s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
			},
			ao: 0,
			w: 126,
			h: 72,
			ip: 400,
			op: 720,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 3,
			ty: 0,
			nm: 'Links Card',
			refId: 'comp_6',
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 400,
							s: [0],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 410,
							s: [100],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 600,
							s: [100],
						},
						{ t: 610, s: [0] },
					],
					ix: 11,
				},
				r: { a: 0, k: 0, ix: 10 },
				p: {
					a: 1,
					k: [
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 400,
							s: [268, 176, 0],
							to: [-5, 0, 0],
							ti: [5, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 410,
							s: [238, 176, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 600,
							s: [238, 176, 0],
							to: [-5, 0, 0],
							ti: [5, 0, 0],
						},
						{ t: 610, s: [208, 176, 0] },
					],
					ix: 2,
					l: 2,
				},
				a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
				s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
			},
			ao: 0,
			w: 126,
			h: 76,
			ip: 400,
			op: 720,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 4,
			ty: 0,
			nm: 'Graph Card',
			refId: 'comp_9',
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 400,
							s: [0],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 410,
							s: [100],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 600,
							s: [100],
						},
						{ t: 610, s: [0] },
					],
					ix: 11,
				},
				r: { a: 0, k: 0, ix: 10 },
				p: {
					a: 1,
					k: [
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 400,
							s: [138, 176, 0],
							to: [-5, 0, 0],
							ti: [5, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 410,
							s: [108, 176, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 600,
							s: [108, 176, 0],
							to: [-5, 0, 0],
							ti: [5, 0, 0],
						},
						{ t: 610, s: [78, 176, 0] },
					],
					ix: 2,
					l: 2,
				},
				a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
				s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
			},
			ao: 0,
			w: 126,
			h: 76,
			ip: 400,
			op: 720,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 5,
			ty: 0,
			nm: 'Summary title cards',
			refId: 'comp_13',
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 400,
							s: [0],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 410,
							s: [100],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 600,
							s: [100],
						},
						{ t: 610, s: [0] },
					],
					ix: 11,
				},
				r: { a: 0, k: 0, ix: 10 },
				p: {
					a: 1,
					k: [
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 400,
							s: [138, 148, 0],
							to: [-5, 0, 0],
							ti: [5, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 410,
							s: [108, 148, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 600,
							s: [108, 148, 0],
							to: [-5, 0, 0],
							ti: [5, 0, 0],
						},
						{ t: 610, s: [78, 148, 0] },
					],
					ix: 2,
					l: 2,
				},
				a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
				s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
			},
			ao: 0,
			w: 256,
			h: 24,
			ip: 400,
			op: 720,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 6,
			ty: 0,
			nm: 'Release',
			refId: 'comp_18',
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 220,
							s: [0],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 230,
							s: [100],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 400,
							s: [100],
						},
						{ t: 410, s: [0] },
					],
					ix: 11,
				},
				r: {
					a: 1,
					k: [
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 265,
							s: [0],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 275,
							s: [-3],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 330,
							s: [-3],
						},
						{ t: 340, s: [0] },
					],
					ix: 10,
				},
				p: {
					a: 1,
					k: [
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 220,
							s: [182.5, 167, 0],
							to: [-5, 0, 0],
							ti: [5, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 230,
							s: [152.5, 167, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 265,
							s: [152.5, 167, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 275,
							s: [152.5, 167, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.333, y: 0 },
							t: 300,
							s: [152.5, 167, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.333, y: 0.333 },
							t: 315,
							s: [278.5, 295, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.333, y: 0 },
							t: 330,
							s: [278.5, 295, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 1, y: 1 },
							o: { x: 0.333, y: 0.333 },
							t: 340,
							s: [278.5, 288, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 1, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 400,
							s: [278.5, 288, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{ t: 410, s: [248.5, 288, 0] },
					],
					ix: 2,
					l: 2,
				},
				a: { a: 0, k: [19, 3, 0], ix: 1, l: 2 },
				s: {
					a: 1,
					k: [
						{
							i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
							o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
							t: 265,
							s: [100, 100, 100],
						},
						{
							i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
							o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
							t: 275,
							s: [110, 110, 100],
						},
						{
							i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
							o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
							t: 330,
							s: [110, 110, 100],
						},
						{ t: 340, s: [100, 100, 100] },
					],
					ix: 6,
					l: 2,
				},
			},
			ao: 0,
			ef: [
				{
					ty: 25,
					nm: 'Drop Shadow',
					np: 8,
					mn: 'ADBE Drop Shadow',
					ix: 1,
					en: 1,
					ef: [
						{
							ty: 2,
							nm: 'Shadow Color',
							mn: 'ADBE Drop Shadow-0001',
							ix: 1,
							v: {
								a: 0,
								k: [0.039215687662, 0.254901975393, 0.556862771511, 1],
								ix: 1,
							},
						},
						{
							ty: 0,
							nm: 'Opacity',
							mn: 'ADBE Drop Shadow-0002',
							ix: 2,
							v: {
								a: 1,
								k: [
									{
										i: { x: [0.833], y: [0.833] },
										o: { x: [0.167], y: [0.167] },
										t: 264,
										s: [0],
									},
									{
										i: { x: [0.833], y: [0.833] },
										o: { x: [0.167], y: [0.167] },
										t: 272,
										s: [76.5],
									},
									{
										i: { x: [0.833], y: [0.833] },
										o: { x: [0.167], y: [0.167] },
										t: 330,
										s: [76.5],
									},
									{ t: 340, s: [0] },
								],
								ix: 2,
							},
						},
						{
							ty: 0,
							nm: 'Direction',
							mn: 'ADBE Drop Shadow-0003',
							ix: 3,
							v: { a: 0, k: 225, ix: 3 },
						},
						{
							ty: 0,
							nm: 'Distance',
							mn: 'ADBE Drop Shadow-0004',
							ix: 4,
							v: { a: 0, k: 3, ix: 4 },
						},
						{
							ty: 0,
							nm: 'Softness',
							mn: 'ADBE Drop Shadow-0005',
							ix: 5,
							v: { a: 0, k: 6, ix: 5 },
						},
						{
							ty: 7,
							nm: 'Shadow Only',
							mn: 'ADBE Drop Shadow-0006',
							ix: 6,
							v: { a: 0, k: 0, ix: 6 },
						},
					],
				},
			],
			w: 38,
			h: 6,
			ip: 0,
			op: 720,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 7,
			ty: 4,
			nm: 'Shape Layer 1',
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 265,
							s: [0],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 275,
							s: [100],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 330,
							s: [100],
						},
						{ t: 340, s: [0] },
					],
					ix: 11,
				},
				r: { a: 0, k: 0, ix: 10 },
				p: {
					a: 1,
					k: [
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 300,
							s: [132.375, 161.875, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 304,
							s: [132.375, 161.875, 0],
							to: [7, 5, 0],
							ti: [-7, -5, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 305,
							s: [174.375, 191.875, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 308,
							s: [174.375, 191.875, 0],
							to: [0, 5.083, 0],
							ti: [-7, -5.083, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 309,
							s: [174.375, 222.375, 0],
							to: [7, 5.083, 0],
							ti: [-7, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 310,
							s: [216.375, 222.375, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 311,
							s: [216.375, 222.375, 0],
							to: [0, 5, 0],
							ti: [0, -5, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 312,
							s: [216.375, 252.375, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 313,
							s: [216.375, 252.375, 0],
							to: [7, 5.167, 0],
							ti: [-7, -5.167, 0],
						},
						{ t: 314, s: [258.375, 283.375, 0] },
					],
					ix: 2,
					l: 2,
				},
				a: { a: 0, k: [-65.625, -30.25, 0], ix: 1, l: 2 },
				s: {
					a: 1,
					k: [
						{
							i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
							o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
							t: 313,
							s: [67.99, 69.479, 100],
						},
						{ t: 314, s: [67.99, 62.417, 100] },
					],
					ix: 6,
					l: 2,
				},
			},
			ao: 0,
			shapes: [
				{
					ty: 'gr',
					it: [
						{
							ty: 'rc',
							d: 1,
							s: { a: 0, k: [59.69, 41.957], ix: 2 },
							p: { a: 0, k: [0, 0], ix: 3 },
							r: { a: 0, k: 0, ix: 4 },
							nm: 'Rectangle Path 1',
							mn: 'ADBE Vector Shape - Rect',
							hd: false,
						},
						{
							ty: 'fl',
							c: { a: 0, k: [0.800000059838, 0.878431432387, 1, 1], ix: 4 },
							o: { a: 0, k: 100, ix: 5 },
							r: 1,
							bm: 0,
							nm: 'Fill 1',
							mn: 'ADBE Vector Graphic - Fill',
							hd: false,
						},
						{
							ty: 'tr',
							p: { a: 0, k: [-36.113, -9.454], ix: 2 },
							a: { a: 0, k: [0, 0], ix: 1 },
							s: { a: 0, k: [101.749, 103.388], ix: 3 },
							r: { a: 0, k: 0, ix: 6 },
							o: { a: 0, k: 100, ix: 7 },
							sk: { a: 0, k: 0, ix: 4 },
							sa: { a: 0, k: 0, ix: 5 },
							nm: 'Transform',
						},
					],
					nm: 'Rectangle 1',
					np: 3,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: 'ADBE Vector Group',
					hd: false,
				},
			],
			ip: 265,
			op: 720,
			st: 0,
			ct: 1,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 8,
			ty: 0,
			nm: 'Calendar',
			refId: 'comp_19',
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 220,
							s: [0],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 230,
							s: [100],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 400,
							s: [100],
						},
						{ t: 410, s: [0] },
					],
					ix: 11,
				},
				r: { a: 0, k: 0, ix: 10 },
				p: {
					a: 1,
					k: [
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 220,
							s: [266, 229, 0],
							to: [-5, 0, 0],
							ti: [5, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 230,
							s: [236, 229, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 400,
							s: [236, 229, 0],
							to: [-3.333, 0, 0],
							ti: [3.333, 0, 0],
						},
						{ t: 410, s: [216, 229, 0] },
					],
					ix: 2,
					l: 2,
				},
				a: { a: 0, k: [128, 81, 0], ix: 1, l: 2 },
				s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
			},
			ao: 0,
			w: 256,
			h: 162,
			ip: 220,
			op: 720,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 9,
			ty: 0,
			nm: 'Card',
			refId: 'comp_20',
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 220,
							s: [100],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 226,
							s: [0],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 600,
							s: [0],
						},
						{ t: 610, s: [100] },
					],
					ix: 11,
				},
				r: {
					a: 1,
					k: [
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 60,
							s: [0],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 68,
							s: [-4],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 150,
							s: [-4],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 160,
							s: [2],
						},
						{ t: 165, s: [0] },
					],
					ix: 10,
				},
				p: {
					a: 1,
					k: [
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 60,
							s: [137, 251, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.333, y: 0 },
							t: 105,
							s: [137, 251, 0],
							to: [11, -0.667, 0],
							ti: [-23.5, 2.667, 0],
						},
						{ t: 115.674, s: [203, 247, 0], h: 1 },
						{
							i: { x: 1, y: 1 },
							o: { x: 0.333, y: 0 },
							t: 150,
							s: [203, 247, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.333, y: 0.333 },
							t: 160,
							s: [203, 251, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 220,
							s: [203, 251, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 230,
							s: [173, 251, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 600,
							s: [167, 251, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{ t: 610, s: [137, 251, 0] },
					],
					ix: 2,
					l: 2,
				},
				a: { a: 0, k: [25, 16, 0], ix: 1, l: 2 },
				s: {
					a: 1,
					k: [
						{
							i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
							o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
							t: 60,
							s: [100, 100, 100],
						},
						{
							i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
							o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
							t: 68,
							s: [110, 110, 100],
						},
						{
							i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
							o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
							t: 105,
							s: [110, 110, 100],
						},
						{
							i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
							o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
							t: 150,
							s: [110, 110, 100],
						},
						{
							i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
							o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
							t: 160,
							s: [90, 90, 100],
						},
						{ t: 165, s: [100, 100, 100] },
					],
					ix: 6,
					l: 2,
				},
			},
			ao: 0,
			ef: [
				{
					ty: 25,
					nm: 'Drop Shadow',
					np: 8,
					mn: 'ADBE Drop Shadow',
					ix: 1,
					en: 1,
					ef: [
						{
							ty: 2,
							nm: 'Shadow Color',
							mn: 'ADBE Drop Shadow-0001',
							ix: 1,
							v: {
								a: 0,
								k: [0.039215687662, 0.254901975393, 0.556862771511, 1],
								ix: 1,
							},
						},
						{
							ty: 0,
							nm: 'Opacity',
							mn: 'ADBE Drop Shadow-0002',
							ix: 2,
							v: {
								a: 1,
								k: [
									{
										i: { x: [0.833], y: [0.833] },
										o: { x: [0.167], y: [0.167] },
										t: 60,
										s: [0],
									},
									{
										i: { x: [0.833], y: [0.833] },
										o: { x: [0.167], y: [0.167] },
										t: 68,
										s: [76.5],
									},
									{
										i: { x: [0.833], y: [0.833] },
										o: { x: [0.167], y: [0.167] },
										t: 150,
										s: [76.5],
									},
									{ t: 160, s: [0] },
								],
								ix: 2,
							},
						},
						{
							ty: 0,
							nm: 'Direction',
							mn: 'ADBE Drop Shadow-0003',
							ix: 3,
							v: { a: 0, k: 225, ix: 3 },
						},
						{
							ty: 0,
							nm: 'Distance',
							mn: 'ADBE Drop Shadow-0004',
							ix: 4,
							v: { a: 0, k: 3, ix: 4 },
						},
						{
							ty: 0,
							nm: 'Softness',
							mn: 'ADBE Drop Shadow-0005',
							ix: 5,
							v: { a: 0, k: 6, ix: 5 },
						},
						{
							ty: 7,
							nm: 'Shadow Only',
							mn: 'ADBE Drop Shadow-0006',
							ix: 6,
							v: { a: 0, k: 0, ix: 6 },
						},
					],
				},
			],
			w: 50,
			h: 32,
			ip: 0,
			op: 720,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 10,
			ty: 0,
			nm: 'Boards',
			refId: 'comp_21',
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 60,
							s: [100],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 70,
							s: [80],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 150,
							s: [80],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 160,
							s: [100],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 220,
							s: [100],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 230,
							s: [0],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 600,
							s: [0],
						},
						{ t: 610, s: [100] },
					],
					ix: 11,
				},
				r: { a: 0, k: 0, ix: 10 },
				p: {
					a: 1,
					k: [
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 0,
							s: [108, 146, 0],
							to: [0, 0, 0],
							ti: [0, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 220,
							s: [108, 146, 0],
							to: [-5, 0, 0],
							ti: [-5, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 230,
							s: [78, 146, 0],
							to: [5, 0, 0],
							ti: [-5, 0, 0],
						},
						{
							i: { x: 0.833, y: 0.833 },
							o: { x: 0.167, y: 0.167 },
							t: 600,
							s: [138, 146, 0],
							to: [5, 0, 0],
							ti: [5, 0, 0],
						},
						{ t: 610, s: [108, 146, 0] },
					],
					ix: 2,
					l: 2,
				},
				a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
				s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
			},
			ao: 0,
			w: 256,
			h: 166,
			ip: 0,
			op: 720,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 11,
			ty: 0,
			nm: 'Tabs',
			refId: 'comp_22',
			sr: 1,
			ks: {
				o: { a: 0, k: 100, ix: 11 },
				r: { a: 0, k: 0, ix: 10 },
				p: { a: 0, k: [108, 130, 0], ix: 2, l: 2 },
				a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
				s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
			},
			ao: 0,
			w: 116,
			h: 4,
			ip: 0,
			op: 720,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 12,
			ty: 5,
			nm: 'Board title',
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 220,
							s: [100],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 230,
							s: [0],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 600,
							s: [0],
						},
						{ t: 610, s: [100] },
					],
					ix: 11,
				},
				r: { a: 0, k: 0, ix: 10 },
				p: { a: 0, k: [132, 117.25, 0], ix: 2, l: 2 },
				a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
				s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
			},
			ao: 0,
			t: {
				d: {
					k: [
						{
							s: {
								sz: [48, 19],
								ps: [-24, -9.5],
								s: 16,
								f: 'Helvetica-Bold',
								t: 'Board',
								ca: 0,
								j: 0,
								tr: 0,
								lh: 1.1875,
								ls: 0,
								fc: [1, 1, 1],
							},
							t: 0,
						},
					],
				},
				p: {},
				m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
				a: [],
			},
			ip: 0,
			op: 631,
			st: 0,
			ct: 1,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 13,
			ty: 5,
			nm: 'Summary title',
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 220,
							s: [0],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 230,
							s: [100],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 400,
							s: [0],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 410,
							s: [100],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 600,
							s: [100],
						},
						{ t: 610, s: [0] },
					],
					ix: 11,
				},
				r: { a: 0, k: 0, ix: 10 },
				p: { a: 0, k: [132, 117.25, 0], ix: 2, l: 2 },
				a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
				s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
			},
			ao: 0,
			t: {
				d: {
					k: [
						{
							s: {
								sz: [117.5, 19],
								ps: [-24, -9.5],
								s: 16,
								f: 'Helvetica-Bold',
								t: 'Summary',
								ca: 0,
								j: 0,
								tr: 0,
								lh: 1.1875,
								ls: 0,
								fc: [1, 1, 1],
							},
							t: 0,
						},
					],
				},
				p: {},
				m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
				a: [],
			},
			ip: 401,
			op: 720,
			st: 0,
			ct: 1,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 14,
			ty: 5,
			nm: 'Calendar title',
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 220,
							s: [0],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 230,
							s: [100],
						},
						{
							i: { x: [0.833], y: [0.833] },
							o: { x: [0.167], y: [0.167] },
							t: 400,
							s: [100],
						},
						{ t: 410, s: [0] },
					],
					ix: 11,
				},
				r: { a: 0, k: 0, ix: 10 },
				p: { a: 0, k: [132, 117.25, 0], ix: 2, l: 2 },
				a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
				s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
			},
			ao: 0,
			t: {
				d: {
					k: [
						{
							s: {
								sz: [117.5, 19],
								ps: [-24, -9.5],
								s: 16,
								f: 'Helvetica-Bold',
								t: 'Calendar',
								ca: 0,
								j: 0,
								tr: 0,
								lh: 1.1875,
								ls: 0,
								fc: [1, 1, 1],
							},
							t: 0,
						},
					],
				},
				p: {},
				m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
				a: [],
			},
			ip: 220,
			op: 720,
			st: 0,
			ct: 1,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 15,
			ty: 0,
			nm: 'Screen',
			refId: 'comp_23',
			sr: 1,
			ks: {
				o: { a: 0, k: 100, ix: 11 },
				r: { a: 0, k: 0, ix: 10 },
				p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
				a: { a: 0, k: [180, 128, 0], ix: 1, l: 2 },
				s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
			},
			ao: 0,
			ef: [
				{
					ty: 25,
					nm: 'Drop Shadow',
					np: 8,
					mn: 'ADBE Drop Shadow',
					ix: 1,
					en: 1,
					ef: [
						{
							ty: 2,
							nm: 'Shadow Color',
							mn: 'ADBE Drop Shadow-0001',
							ix: 1,
							v: {
								a: 0,
								k: [0.043137256056, 0.313725501299, 0.694117665291, 1],
								ix: 1,
							},
						},
						{
							ty: 0,
							nm: 'Opacity',
							mn: 'ADBE Drop Shadow-0002',
							ix: 2,
							v: { a: 0, k: 76.5, ix: 2 },
						},
						{
							ty: 0,
							nm: 'Direction',
							mn: 'ADBE Drop Shadow-0003',
							ix: 3,
							v: { a: 0, k: 225, ix: 3 },
						},
						{
							ty: 0,
							nm: 'Distance',
							mn: 'ADBE Drop Shadow-0004',
							ix: 4,
							v: { a: 0, k: 5, ix: 4 },
						},
						{
							ty: 0,
							nm: 'Softness',
							mn: 'ADBE Drop Shadow-0005',
							ix: 5,
							v: { a: 0, k: 10, ix: 5 },
						},
						{
							ty: 7,
							nm: 'Shadow Only',
							mn: 'ADBE Drop Shadow-0006',
							ix: 6,
							v: { a: 0, k: 0, ix: 6 },
						},
					],
				},
			],
			w: 360,
			h: 256,
			ip: 0,
			op: 720,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 16,
			ty: 0,
			nm: 'Background',
			refId: 'comp_24',
			sr: 1,
			ks: {
				o: { a: 0, k: 100, ix: 11 },
				r: { a: 0, k: 0, ix: 10 },
				p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
				a: { a: 0, k: [200, 200, 0], ix: 1, l: 2 },
				s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
			},
			ao: 0,
			w: 400,
			h: 400,
			ip: 0,
			op: 720,
			st: 0,
			bm: 0,
		},
	],
	markers: [],
	props: {},
	chars: [
		{
			ch: 'B',
			size: 10,
			style: 'Regular',
			w: 66.7,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[-2.171, -0.911],
											[0, -4.688],
											[3.618, -1.79],
											[4.144, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[4.276, 0],
											[3.848, 1.628],
											[0, 4.655],
											[-2.303, 1.14],
											[0, 0],
										],
										v: [
											[16.895, -41.406],
											[16.895, -63.623],
											[34.41, -63.623],
											[44.081, -62.256],
											[49.854, -52.783],
											[44.426, -43.115],
											[34.756, -41.406],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'B',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
							{
								ind: 1,
								ty: 'sh',
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[-2.498, -1.009],
											[0, -5.208],
											[1.61, -2.18],
											[6.013, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[4.108, 0],
											[4.699, 1.888],
											[0, 3.093],
											[-2.563, 3.451],
											[0, 0],
										],
										v: [
											[16.895, -8.301],
											[16.895, -33.545],
											[36.364, -33.545],
											[46.272, -32.031],
											[53.32, -21.387],
											[50.905, -13.477],
											[38.04, -8.301],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'B',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
							{
								ind: 2,
								ty: 'sh',
								ix: 3,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[0, 0],
											[-4.356, 5.599],
											[0, 4.623],
											[3.223, 3.125],
											[3.678, 1.4],
											[-1.335, 1.53],
											[0, 4.525],
											[2.097, 2.962],
											[8.453, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[9.498, 0],
											[2.914, -3.743],
											[0, -5.501],
											[-1.823, -1.758],
											[2.506, -1.27],
											[2.571, -2.897],
											[0, -3.873],
											[-3.572, -5.013],
											[0, 0],
											[0, 0],
										],
										v: [
											[7.373, 0],
											[37.883, 0],
											[58.665, -8.398],
											[63.037, -20.947],
											[58.203, -33.887],
											[49.951, -38.623],
											[55.713, -42.822],
											[59.57, -53.955],
											[56.425, -64.209],
											[38.387, -71.729],
											[7.373, -71.729],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'B',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'B',
						np: 6,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'u',
			size: 10,
			style: 'Regular',
			w: 55.62,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[0, 0],
											[-1.437, -2.669],
											[-7.315, 0],
											[-3.29, 2.734],
											[-1.119, 1.986],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[1.173, -2.93],
											[5.959, 0],
											[1.521, 3.125],
											[0, 2.67],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 4.46],
											[2.65, 4.98],
											[4.695, 0],
											[1.661, -1.367],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 5.111],
											[-2.156, 5.469],
											[-4.153, 0],
											[-0.825, -1.692],
											[0, 0],
											[0, 0],
										],
										v: [
											[6.25, -52.295],
											[6.25, -16.748],
											[8.406, -6.055],
											[23.354, 1.416],
											[35.332, -2.686],
											[39.502, -7.715],
											[39.404, 0],
											[47.705, 0],
											[47.705, -52.295],
											[38.916, -52.295],
											[38.916, -26.611],
											[37.157, -14.551],
											[24.983, -6.348],
											[16.471, -11.035],
											[15.234, -17.578],
											[15.234, -52.295],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'u',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'u',
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 's',
			size: 10,
			style: 'Regular',
			w: 50,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[-3.279, -3.532],
											[-7.877, 0],
											[-3.576, 3.385],
											[0, 4.655],
											[3.418, 2.246],
											[6.434, 1.53],
											[0, 0],
											[1.326, 0.811],
											[0, 2.271],
											[-1.749, 1.265],
											[-3.399, 0],
											[-2.066, -2.298],
											[-0.167, -1.974],
											[0, 0],
											[2.21, 2.93],
											[7.983, 0],
											[3.612, -3.059],
											[0, -4.948],
											[-3.838, -2.376],
											[-4.532, -1.106],
											[0, 0],
											[-1.291, -0.716],
											[0, -2.246],
											[2.525, -1.416],
											[3.322, 0],
											[2.259, 2.832],
											[0.266, 2.93],
										],
										o: [
											[0.23, 5.209],
											[3.279, 3.532],
											[7.317, 0],
											[3.576, -3.385],
											[0, -4.817],
											[-2.19, -1.432],
											[0, 0],
											[-2.587, -0.618],
											[-2.299, -1.363],
											[0, -2.075],
											[1.749, -1.265],
											[5.098, 0],
											[1.266, 1.619],
											[0, 0],
											[0.065, -3.385],
											[-3.529, -4.622],
											[-6.104, 0],
											[-3.613, 3.06],
											[0, 4.199],
											[2.15, 1.367],
											[0, 0],
											[3.804, 0.945],
											[2.018, 1.172],
											[0, 2.962],
											[-2.525, 1.416],
											[-5.582, 0],
											[-1.23, -1.562],
											[0, 0],
										],
										v: [
											[3.223, -16.406],
											[8.488, -3.296],
											[25.221, 2.002],
											[41.56, -3.076],
											[46.924, -15.137],
											[41.797, -25.732],
											[28.862, -30.176],
											[22.942, -31.592],
											[17.072, -33.736],
											[13.623, -39.185],
											[16.247, -44.196],
											[23.969, -46.094],
											[34.716, -42.646],
											[36.865, -37.256],
											[45.166, -37.256],
											[41.948, -46.729],
											[24.679, -53.662],
											[10.106, -49.072],
											[4.688, -37.061],
											[10.444, -27.197],
											[20.467, -23.486],
											[27.563, -21.729],
											[35.205, -19.238],
											[38.232, -14.111],
											[34.444, -7.544],
											[25.674, -5.42],
											[13.912, -9.668],
											[11.67, -16.406],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 's',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 's',
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'i',
			size: 10,
			style: 'Regular',
			w: 22.22,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[6.445, 0],
											[15.381, 0],
											[15.381, -52.051],
											[6.445, -52.051],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'i',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
							{
								ind: 1,
								ty: 'sh',
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[6.445, -61.768],
											[15.381, -61.768],
											[15.381, -71.729],
											[6.445, -71.729],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'i',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'i',
						np: 5,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'n',
			size: 10,
			style: 'Regular',
			w: 55.62,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[-0.439, 1.839],
											[-1.465, 1.726],
											[-2.409, 0.716],
											[-2.084, 0],
											[-1.562, -3.255],
											[0, -3.19],
											[0, 0],
											[0, 0],
											[0, 0],
											[1.432, 2.832],
											[7.422, 0],
											[2.766, -1.334],
											[2.473, -3.059],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, -3.418],
											[0.439, -1.839],
											[1.823, -2.148],
											[1.334, -0.423],
											[4.102, 0],
											[0.944, 1.953],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, -5.273],
											[-2.605, -5.176],
											[-3.386, 0],
											[-2.767, 1.335],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[6.445, 0],
											[15.234, 0],
											[15.234, -27.393],
											[15.894, -35.278],
											[18.75, -40.625],
											[25.098, -44.922],
											[30.225, -45.557],
											[38.721, -40.674],
											[40.137, -32.959],
											[40.137, 0],
											[49.072, 0],
											[49.072, -33.545],
											[46.924, -45.703],
											[31.885, -53.467],
											[22.656, -51.465],
											[14.795, -44.873],
											[14.795, -52.295],
											[6.445, -52.295],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'n',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'n',
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'e',
			size: 10,
			style: 'Regular',
			w: 55.62,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[3.688, 0],
											[4.529, -5.241],
											[0, -8.398],
											[-4.497, -4.736],
											[-6.47, 0],
											[-2.1, 0.52],
											[-2.65, 2.605],
											[-1.286, 2.361],
											[-0.228, 1.921],
											[0, 0],
											[1.518, -1.765],
											[4.554, 0],
											[2.325, 3.215],
											[0.162, 5.321],
											[0, 0],
											[0.517, 2.409],
											[1.747, 2.637],
											[3.461, 1.742],
										],
										o: [
											[-7.312, 0],
											[-4.53, 5.241],
											[0, 8.529],
											[4.497, 4.736],
											[2.649, 0],
											[3.909, -0.912],
											[1.582, -1.497],
											[1.286, -2.36],
											[0, 0],
											[-0.633, 2.322],
											[-2.713, 3.041],
											[-4.877, 0],
											[-2.325, -3.215],
											[0, 0],
											[0, -5.273],
											[-0.583, -3.516],
											[-1.812, -2.766],
											[-3.462, -1.741],
										],
										v: [
											[28.022, -53.467],
											[10.261, -45.605],
											[3.467, -25.146],
											[10.211, -5.249],
											[26.661, 1.855],
											[33.784, 1.074],
											[43.622, -4.199],
											[47.925, -9.985],
											[50.195, -16.406],
											[41.553, -16.406],
											[38.326, -10.275],
											[27.425, -5.713],
											[16.621, -10.535],
											[12.891, -23.34],
											[50.928, -23.34],
											[50.151, -34.863],
											[46.657, -44.092],
											[38.747, -50.854],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'e',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
							{
								ind: 1,
								ty: 'sh',
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[-2.711, 2.914],
											[-4.002, 0],
											[-2.389, -4.231],
											[-0.356, -3.809],
										],
										o: [
											[0.161, -4.492],
											[2.711, -2.913],
											[5.584, 0],
											[1.291, 2.279],
											[0, 0],
										],
										v: [
											[13.086, -30.322],
											[17.395, -41.431],
											[27.466, -45.801],
											[39.425, -39.453],
											[41.895, -30.322],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'e',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'e',
						np: 5,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{ ch: ' ', size: 10, style: 'Regular', w: 27.78, data: {}, fFamily: 'Helvetica' },
		{
			ch: 'p',
			size: 10,
			style: 'Regular',
			w: 55.62,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[4.115, 0],
											[2.286, 5.404],
											[0, 4.037],
											[-1.208, 3.255],
											[-6.108, 0],
											[-2.287, -5.762],
											[0, -4.166],
											[2.727, -3.434],
										],
										o: [
											[-6.076, 0],
											[-1.208, -2.832],
											[0, -5.013],
											[2.254, -6.087],
											[6.075, 0],
											[1.208, 2.995],
											[0, 6.836],
											[-2.728, 3.435],
										],
										v: [
											[28.516, -5.908],
											[15.973, -14.014],
											[14.16, -24.316],
											[15.973, -36.719],
											[28.516, -45.85],
											[41.058, -37.207],
											[42.871, -26.465],
											[38.78, -11.06],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'p',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
							{
								ind: 1,
								ty: 'sh',
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[-1.569, -0.977],
											[-3.954, 0],
											[-3.791, 3.092],
											[0, 11.394],
											[4.144, 4.541],
											[5.94, 0],
											[2.969, -1.953],
											[1.762, -2.376],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[1.928, 2.377],
											[2.679, 1.725],
											[5.032, 0],
											[5.98, -4.883],
											[0, -8.43],
											[-4.145, -4.541],
											[-4.015, 0],
											[-2.089, 1.302],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[5.713, 20.85],
											[14.502, 20.85],
											[14.502, -5.859],
											[19.747, -0.83],
											[29.698, 1.758],
											[42.934, -2.881],
											[51.904, -27.295],
											[45.687, -46.753],
											[30.56, -53.564],
											[20.084, -50.635],
											[14.307, -45.117],
											[14.307, -52.051],
											[5.713, -52.051],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'p',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'p',
						np: 5,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'r',
			size: 10,
			style: 'Regular',
			w: 33.3,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[-2.377, 2.849],
											[-4.427, 0],
											[-0.439, -0.032],
											[-0.521, -0.098],
											[0, 0],
											[0.391, 0.033],
											[0.163, 0],
											[2.669, -2.522],
											[0.684, -1.758],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, -3.711],
											[2.376, -2.848],
											[0.52, 0],
											[0.439, 0.033],
											[0, 0],
											[-0.945, -0.098],
											[-0.391, -0.032],
											[-3.484, 0],
											[-2.67, 2.523],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[6.689, 0],
											[15.479, 0],
											[15.479, -30.078],
											[19.043, -39.917],
											[29.248, -44.189],
											[30.688, -44.141],
											[32.129, -43.945],
											[32.129, -53.223],
											[30.127, -53.418],
											[29.297, -53.467],
											[20.068, -49.683],
											[15.039, -43.262],
											[15.039, -52.295],
											[6.689, -52.295],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'r',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'r',
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'o',
			size: 10,
			style: 'Regular',
			w: 55.62,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[5.761, 0],
											[2.414, 3.706],
											[0, 5.56],
											[-2.414, 4.097],
											[-5.312, 0],
											[-2.446, -4.812],
											[0, -4.877],
											[2.141, -4.405],
										],
										o: [
											[-5.247, 0],
											[-2.414, -3.706],
											[0, -5.787],
											[2.414, -4.097],
											[5.987, 0],
											[1.545, 3.056],
											[0, 5.397],
											[-2.141, 4.405],
										],
										v: [
											[27.026, -5.713],
											[15.535, -11.272],
											[11.914, -25.172],
											[15.535, -39.997],
											[27.122, -46.143],
											[39.772, -38.924],
											[42.09, -27.025],
											[38.879, -12.321],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'o',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
							{
								ind: 1,
								ty: 'sh',
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[6.691, 0],
											[4.428, -5.203],
											[0, -8.781],
											[-4.202, -4.862],
											[-7.144, 0],
											[-4.073, 5.496],
											[0, 8.424],
											[4.622, 4.488],
										],
										o: [
											[-7.467, 0],
											[-4.428, 5.204],
											[0, 8.196],
											[4.202, 4.862],
											[8.566, 0],
											[4.073, -5.496],
											[0, -8.716],
											[-4.623, -4.488],
										],
										v: [
											[27.366, -53.809],
											[9.523, -46.003],
											[2.881, -25.025],
											[9.184, -5.437],
											[26.202, 1.855],
											[45.16, -6.389],
											[51.27, -27.27],
											[44.336, -47.076],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'o',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'o',
						np: 5,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'j',
			size: 10,
			style: 'Regular',
			w: 22.22,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[15.234, -71.729],
											[6.445, -71.729],
											[6.445, -61.572],
											[15.234, -61.572],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'j',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
							{
								ind: 1,
								ty: 'sh',
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[-0.471, -0.033],
											[-0.423, 0],
											[-2.051, 3.19],
											[0, 3.809],
											[0, 0],
											[0, 0],
											[0, 0],
											[0.797, -0.57],
											[3.938, -0.13],
										],
										o: [
											[1.009, 0.098],
											[0.471, 0.032],
											[5.729, 0],
											[1.237, -1.888],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 2.995],
											[-0.798, 0.569],
											[0, 0],
										],
										v: [
											[-1.855, 20.85],
											[0.366, 21.045],
											[1.709, 21.094],
											[13.379, 16.309],
											[15.234, 7.764],
											[15.234, -52.051],
											[6.445, -52.051],
											[6.445, 6.836],
											[5.249, 12.183],
											[-1.855, 13.232],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'j',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'j',
						np: 5,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'c',
			size: 10,
			style: 'Regular',
			w: 50,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[5.891, 0],
											[4.459, -5.11],
											[0, -9.18],
											[-4.07, -4.996],
											[-6.836, 0],
											[-3.906, 3.207],
											[-0.977, 6.934],
											[0, 0],
											[2.132, -2.221],
											[3.645, 0],
											[2.213, 3.577],
											[0, 5.235],
											[-1.562, 3.544],
											[-5.599, 0],
											[-1.855, -2.132],
											[-0.521, -3.223],
											[0, 0],
											[3.694, 2.865],
										],
										o: [
											[-6.902, 0],
											[-4.46, 5.111],
											[0, 7.487],
											[4.069, 4.997],
											[6.087, 0],
											[3.906, -3.206],
											[0, 0],
											[-0.814, 3.859],
											[-2.132, 2.222],
											[-4.753, 0],
											[-2.214, -3.577],
											[0, -5.202],
											[2.409, -5.462],
											[4.102, 0],
											[1.855, 2.132],
											[0, 0],
											[-0.749, -6.998],
											[-3.695, -2.864],
										],
										v: [
											[26.611, -53.809],
											[9.57, -46.143],
											[2.881, -24.707],
											[8.984, -5.981],
											[25.342, 1.514],
											[40.332, -3.296],
											[47.656, -18.506],
											[39.111, -18.506],
											[34.692, -9.386],
											[26.025, -6.055],
											[15.576, -11.419],
											[12.256, -24.635],
											[14.6, -37.754],
											[26.611, -45.947],
											[35.547, -42.749],
											[39.111, -34.717],
											[47.656, -34.717],
											[40.991, -49.512],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'c',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'c',
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 't',
			size: 10,
			style: 'Regular',
			w: 27.78,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[-1.465, -2.1],
											[-4.102, 0],
											[-1.091, 0.13],
											[-1.009, 0.293],
											[0, 0],
											[0.488, -0.021],
											[0.423, 0],
											[0.684, 0.359],
											[0, 1.823],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 3.353],
											[1.465, 2.1],
											[1.27, 0],
											[1.09, -0.13],
											[0, 0],
											[-0.652, 0.087],
											[-0.488, 0.021],
											[-1.595, 0],
											[-1.237, -0.618],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[8.203, -52.295],
											[1.123, -52.295],
											[1.123, -45.117],
											[8.203, -45.117],
											[8.203, -10.498],
											[10.4, -2.319],
											[18.75, 0.83],
											[22.29, 0.635],
											[25.439, 0],
											[25.439, -6.982],
											[23.73, -6.819],
											[22.363, -6.787],
											[18.945, -7.324],
											[17.09, -10.986],
											[17.09, -45.117],
											[25.439, -45.117],
											[25.439, -52.295],
											[17.09, -52.295],
											[17.09, -66.895],
											[8.203, -66.895],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 't',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 't',
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'C',
			size: 16,
			style: 'Bold',
			w: 72.22,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[-1.302, 7.845],
											[0, 0],
											[1.53, -1.855],
											[5.273, 0],
											[3.336, 4.021],
											[0, 8.073],
											[-3.158, 4.411],
											[-5.469, 0],
											[-2.734, -3.125],
											[-0.977, -3.45],
											[0, 0],
											[3.092, 4.46],
											[12.109, 0],
											[5.859, -5.924],
											[0, -12.565],
											[-5.925, -6.673],
											[-10.352, 0],
											[-5.371, 4.916],
										],
										o: [
											[0, 0],
											[-1.009, 3.711],
											[-2.767, 3.451],
											[-5.144, 0],
											[-3.337, -4.02],
											[0, -8.073],
											[3.157, -4.411],
											[5.371, 0],
											[1.53, 1.758],
											[0, 0],
											[-0.228, -4.492],
											[-5.599, -7.942],
											[-9.05, 0],
											[-6.738, 6.804],
											[0, 11.621],
											[5.924, 6.641],
											[8.366, 0],
											[5.338, -4.915],
										],
										v: [
											[68.359, -24.512],
											[53.467, -24.512],
											[49.658, -16.162],
											[37.598, -10.986],
											[24.878, -17.017],
											[19.873, -35.156],
											[24.609, -53.882],
											[37.549, -60.498],
											[49.707, -55.811],
											[53.467, -47.998],
											[68.506, -47.998],
											[63.525, -61.426],
											[36.963, -73.34],
											[14.6, -64.453],
											[4.492, -35.4],
											[13.379, -7.959],
											[37.793, 2.002],
											[58.398, -5.371],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'C',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'C',
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'a',
			size: 16,
			style: 'Bold',
			w: 55.62,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[0.293, -4.655],
											[0, 0],
											[-0.977, 1.205],
											[-3.288, 0],
											[-1.514, -0.83],
											[0, -2.18],
											[1.985, -0.846],
											[2.571, -0.325],
											[0, 0],
											[2.766, -1.595],
											[0, -6.543],
											[-3.142, -2.75],
											[-4.818, 0],
											[-2.995, 1.725],
											[-1.921, 2.084],
											[-0.163, -0.944],
											[-0.423, -1.074],
											[0, 0],
											[0, 0],
											[0.455, 0.652],
											[0.098, 1.823],
											[0, 1.693],
											[0, 0],
											[4.524, 2.312],
											[5.827, 0],
											[3.678, -4.688],
										],
										o: [
											[0, 0],
											[0.325, -2.051],
											[1.367, -1.627],
											[2.93, 0],
											[1.514, 0.83],
											[0, 1.791],
											[-1.107, 0.488],
											[0, 0],
											[-5.371, 0.684],
											[-5.046, 2.93],
											[0, 5.046],
											[3.141, 2.75],
											[3.776, 0],
											[2.506, -1.465],
											[0.098, 1.205],
											[0.163, 0.945],
											[0, 0],
											[0, 0],
											[-0.912, -0.423],
											[-0.456, -0.651],
											[-0.066, -2.409],
											[0, 0],
											[0, -6.413],
											[-4.525, -2.311],
											[-8.952, 0],
											[-2.312, 2.995],
										],
										v: [
											[4.59, -35.986],
											[18.018, -35.986],
											[19.971, -40.869],
											[26.953, -43.311],
											[33.618, -42.065],
											[35.889, -37.549],
											[32.91, -33.594],
											[27.393, -32.373],
											[22.656, -31.787],
											[10.449, -28.369],
											[2.881, -14.16],
											[7.593, -2.466],
											[19.531, 1.66],
											[29.688, -0.928],
											[36.328, -6.25],
											[36.719, -3.027],
											[37.598, 0],
											[52.734, 0],
											[52.734, -2.051],
											[50.684, -3.662],
											[49.854, -7.373],
											[49.756, -13.525],
											[49.756, -37.939],
											[42.969, -51.025],
											[27.441, -54.492],
											[8.496, -47.461],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'a',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
							{
								ind: 1,
								ty: 'sh',
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 2.377],
											[-2.148, 1.27],
											[-2.93, 0.521],
											[0, 0],
											[-0.896, 0.342],
											[-0.879, 0.554],
											[0, 0],
											[2.522, -1.758],
											[2.995, 0],
											[1.302, 1.074],
										],
										o: [
											[0, -2.669],
											[1.27, -0.748],
											[0, 0],
											[1.562, -0.293],
											[0.895, -0.342],
											[0, 0],
											[-0.098, 4.655],
											[-2.523, 1.758],
											[-1.888, 0],
											[-1.335, -1.041],
										],
										v: [
											[16.846, -15.186],
											[20.068, -21.094],
											[26.367, -22.998],
											[29.492, -23.584],
											[33.179, -24.536],
											[35.84, -25.879],
											[35.84, -20.703],
											[31.909, -11.084],
											[23.633, -8.447],
											[18.848, -10.059],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'a',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'a',
						np: 5,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'l',
			size: 16,
			style: 'Bold',
			w: 27.78,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[6.787, 0],
											[20.703, 0],
											[20.703, -71.973],
											[6.787, -71.973],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'l',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'l',
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'e',
			size: 16,
			style: 'Bold',
			w: 55.62,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[0.977, -0.879],
											[2.864, 0],
											[1.92, 1.335],
											[0.195, 5.339],
											[0, 0],
											[0.358, 2.441],
											[2.083, 3.158],
											[3.548, 1.66],
											[4.427, 0],
											[4.671, -4.915],
											[0, -9.212],
											[-5.176, -4.362],
											[-6.771, 0],
											[-4.558, 5.176],
											[-0.359, 3.158],
										],
										o: [
											[-0.749, 1.562],
											[-1.791, 1.628],
											[-2.702, 0],
											[-3.158, -2.148],
											[0, 0],
											[0.065, -4.59],
											[-0.619, -4.166],
											[-2.312, -3.58],
											[-3.548, -1.66],
											[-7.455, 0],
											[-4.671, 4.916],
											[0, 9.831],
											[5.176, 4.362],
											[8.203, 0],
											[2.93, -3.255],
											[0, 0],
										],
										v: [
											[37.842, -15.625],
											[35.254, -11.963],
											[28.271, -9.521],
											[21.338, -11.523],
											[16.309, -22.754],
											[52.734, -22.754],
											[52.295, -33.301],
											[48.242, -44.287],
											[39.453, -52.148],
											[27.49, -54.639],
											[9.302, -47.266],
											[2.295, -26.074],
											[10.059, -4.785],
											[27.979, 1.758],
											[47.119, -6.006],
											[52.051, -15.625],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'e',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
							{
								ind: 1,
								ty: 'sh',
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[-1.775, 2.019],
											[-3.223, 0],
											[-2.002, -1.904],
											[-0.228, -3.678],
										],
										o: [
											[0.455, -3.45],
											[1.774, -2.018],
											[2.962, 0],
											[2.002, 1.904],
											[0, 0],
										],
										v: [
											[16.65, -31.934],
											[19.995, -40.137],
											[27.49, -43.164],
											[34.937, -40.308],
											[38.281, -31.934],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'e',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'e',
						np: 5,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'n',
			size: 16,
			style: 'Bold',
			w: 61.08,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[-1.367, -2.734],
											[0, -2.799],
											[0, 0],
											[0, 0],
											[0, 0],
											[3.499, 2.881],
											[5.501, 0],
											[2.864, -2.148],
											[1.79, -2.734],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[-0.912, 2.116],
											[-4.72, 0],
										],
										o: [
											[0.748, 1.498],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, -6.673],
											[-3.5, -2.881],
											[-4.395, 0],
											[-1.595, 1.205],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, -3.288],
											[1.758, -4.004],
											[3.841, 0],
										],
										v: [
											[39.355, -38.818],
											[40.479, -32.373],
											[40.479, 0],
											[54.736, 0],
											[54.736, -35.84],
											[49.487, -50.171],
											[35.986, -54.492],
											[25.098, -51.27],
											[20.02, -45.361],
											[20.02, -53.125],
											[6.592, -53.125],
											[6.592, 0],
											[20.459, 0],
											[20.459, -28.809],
											[21.826, -36.914],
											[31.543, -42.92],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'n',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'n',
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'd',
			size: 16,
			style: 'Bold',
			w: 61.08,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[0, 0],
											[2.506, 1.416],
											[3.223, 0],
											[4.182, -5.208],
											[0, -9.082],
											[-4.248, -5.029],
											[-6.218, 0],
											[-2.539, 1.432],
											[-1.986, 3.158],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[-1.562, -2.506],
											[-2.507, -1.416],
											[-6.999, 0],
											[-4.183, 5.209],
											[0, 7.878],
											[4.248, 5.029],
											[3.776, 0],
											[2.539, -1.432],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[40.82, -71.875],
											[40.82, -46.484],
											[34.717, -52.368],
											[26.123, -54.492],
											[9.351, -46.68],
											[3.076, -25.244],
											[9.448, -5.884],
											[25.146, 1.66],
											[34.619, -0.488],
											[41.406, -7.373],
											[41.406, 0],
											[54.932, 0],
											[54.932, -71.875],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'd',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
							{
								ind: 1,
								ty: 'sh',
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[-1.904, 3.076],
											[-4.07, 0],
											[-2.019, -1.692],
											[0, -6.51],
											[2.051, -2.93],
											[3.938, 0],
											[1.92, 2.962],
											[0, 4.916],
										],
										o: [
											[1.904, -3.076],
											[2.669, 0],
											[3.288, 2.8],
											[0, 4.655],
											[-2.051, 2.93],
											[-3.939, 0],
											[-1.953, -2.93],
											[0, -4.557],
										],
										v: [
											[20.288, -37.72],
											[29.248, -42.334],
											[36.279, -39.795],
											[41.211, -25.83],
											[38.135, -14.453],
											[29.15, -10.059],
											[20.361, -14.502],
											[17.432, -26.27],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'd',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'd',
						np: 5,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'r',
			size: 16,
			style: 'Bold',
			w: 38.92,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[-0.684, -0.032],
											[-0.879, -0.098],
											[0, 0],
											[0.179, 0.017],
											[0.26, 0],
											[2.604, -2.18],
											[2.148, -3.548],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[-1.074, 2.051],
											[-5.599, 0],
										],
										o: [
											[0.684, 0.033],
											[0, 0],
											[-0.619, -0.032],
											[-0.179, -0.016],
											[-4.167, 0],
											[-1.595, 1.302],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, -4.264],
											[1.92, -3.645],
											[0.423, 0],
										],
										v: [
											[34.912, -40.332],
											[37.256, -40.137],
											[37.256, -54.395],
											[36.06, -54.468],
											[35.4, -54.492],
											[25.244, -51.221],
											[19.629, -43.945],
											[19.629, -53.223],
											[6.348, -53.223],
											[6.348, 0],
											[20.361, 0],
											[20.361, -25.439],
											[21.973, -34.912],
											[33.252, -40.381],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'r',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'r',
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'S',
			size: 16,
			style: 'Bold',
			w: 66.7,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[2.441, 2.962],
											[0.455, 3.288],
											[0, 0],
											[-5.371, -4.28],
											[-9.375, 0],
											[-5.029, 4.346],
											[0, 6.576],
											[4.297, 3.386],
											[5.436, 1.302],
											[0, 0],
											[1.465, 0.847],
											[0, 2.572],
											[-2.312, 1.562],
											[-3.874, 0],
											[-2.344, -1.204],
											[-0.261, -4.329],
											[0, 0],
											[5.354, 4.021],
											[7.584, 0],
											[4.688, -4.264],
											[0, -6.445],
											[-4.851, -3.32],
											[-7.487, -1.692],
											[0, 0],
											[-2.084, -1.27],
											[0, -2.376],
											[4.199, -1.497],
											[3.548, 0],
										],
										o: [
											[-1.335, -1.627],
											[0, 0],
											[0, 7.487],
											[5.371, 4.281],
											[9.18, 0],
											[5.029, -4.346],
											[0, -6.413],
											[-2.767, -2.18],
											[0, 0],
											[-4.785, -1.139],
											[-2.279, -1.27],
											[0, -2.799],
											[2.311, -1.562],
											[3.483, 0],
											[3.516, 1.823],
											[0, 0],
											[-0.261, -7.649],
											[-5.355, -4.02],
											[-9.082, 0],
											[-4.688, 4.265],
											[0, 7.064],
											[2.864, 1.986],
											[0, 0],
											[4.459, 0.977],
											[2.083, 1.302],
											[0, 4.07],
											[-2.214, 0.781],
											[-5.925, 0],
										],
										v: [
											[21.191, -14.844],
											[18.506, -22.217],
											[4.15, -22.217],
											[12.207, -4.565],
											[34.326, 1.855],
											[55.64, -4.663],
											[63.184, -21.045],
											[56.738, -35.742],
											[44.434, -40.967],
											[32.031, -43.945],
											[22.656, -46.924],
											[19.238, -52.686],
											[22.705, -59.229],
											[31.982, -61.572],
											[40.723, -59.766],
											[46.387, -50.537],
											[60.84, -50.537],
											[52.417, -68.042],
											[33.008, -74.072],
											[12.354, -67.676],
											[5.322, -51.611],
											[12.598, -36.035],
											[28.125, -30.518],
											[35.742, -28.809],
											[45.557, -25.439],
											[48.682, -19.922],
											[42.383, -11.572],
											[33.74, -10.4],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'S',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'S',
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'u',
			size: 16,
			style: 'Bold',
			w: 61.08,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0.911, -2.083],
											[4.752, 0],
											[1.27, 2.702],
											[0, 3.027],
											[0, 0],
											[0, 0],
											[0, 0],
											[-1.53, -3.125],
											[-7.878, 0],
											[-2.035, 0.716],
											[-2.181, 1.953],
											[-0.521, 0.814],
											[-0.13, 0.163],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 3.418],
											[-1.758, 3.841],
											[-3.711, 0],
											[-0.716, -1.53],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 6.087],
											[2.734, 5.664],
											[2.734, 0],
											[2.034, -0.716],
											[0.716, -0.618],
											[0.52, -0.813],
											[0, 0],
										],
										v: [
											[40.625, 0],
											[54.15, 0],
											[54.15, -53.223],
											[40.039, -53.223],
											[40.039, -24.268],
											[38.672, -16.016],
											[28.906, -10.254],
											[21.436, -14.307],
											[20.361, -21.143],
											[20.361, -53.223],
											[6.104, -53.223],
											[6.104, -21.143],
											[8.398, -7.324],
											[24.316, 1.172],
											[31.47, 0.098],
											[37.793, -3.906],
											[39.648, -6.055],
											[40.625, -7.52],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'u',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'u',
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'm',
			size: 16,
			style: 'Bold',
			w: 88.92,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[0, -3.157],
											[0, 0],
											[0, 0],
											[0, 0],
											[-0.749, 1.693],
											[-3.841, 0],
											[-1.237, -2.473],
											[0, -2.018],
											[0, 0],
											[0, 0],
											[0, 0],
											[0.325, 1.791],
											[1.497, 1.855],
											[2.278, 0.912],
											[2.344, 0],
											[2.864, -1.465],
											[1.823, -3.125],
											[2.018, 1.66],
											[4.069, 0],
											[2.702, -2.083],
											[1.725, -2.766],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[-0.749, 1.465],
											[-3.972, 0],
											[-1.172, -2.571],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, -2.376],
											[1.465, -3.19],
											[3.32, 0],
											[0.651, 1.302],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, -3.45],
											[-0.521, -2.702],
											[-1.855, -2.278],
											[-2.279, -0.911],
											[-3.516, 0],
											[-2.702, 1.465],
											[-1.042, -2.604],
											[-2.507, -1.79],
											[-4.297, 0],
											[-1.53, 1.172],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, -2.897],
											[1.367, -2.571],
											[3.418, 0],
											[0.651, 1.433],
										],
										v: [
											[37.354, -31.689],
											[37.354, 0],
											[51.367, 0],
											[51.367, -31.689],
											[52.49, -37.793],
											[60.449, -42.578],
											[67.285, -38.867],
											[68.262, -33.887],
											[68.262, 0],
											[82.52, 0],
											[82.617, -33.545],
											[82.129, -41.406],
											[79.102, -48.242],
											[72.9, -53.027],
											[65.967, -54.395],
											[56.396, -52.197],
											[49.609, -45.312],
											[45.02, -51.709],
											[35.156, -54.395],
											[24.658, -51.27],
											[19.775, -45.361],
											[19.775, -53.125],
											[6.25, -53.125],
											[6.25, 0],
											[20.361, 0],
											[20.361, -32.031],
											[21.484, -38.574],
											[29.492, -42.432],
											[36.377, -38.574],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'm',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'm',
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'y',
			size: 16,
			style: 'Bold',
			w: 55.62,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0.7, -1.758],
											[0.813, -0.554],
											[1.237, -0.163],
											[1.367, 0.065],
											[0, 0],
											[0, 0],
											[-0.749, -0.017],
											[-1.237, 0],
											[-2.051, 2.425],
											[-3.516, 10.091],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[0, 0],
											[0, 0],
											[0.13, 0.391],
											[-0.7, 1.758],
											[-0.847, 0.586],
											[-1.237, 0.163],
											[0, 0],
											[0, 0],
											[1.497, 0.098],
											[0.748, 0.016],
											[6.152, 0],
											[2.051, -2.425],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										v: [
											[16.504, -53.223],
											[1.025, -53.223],
											[20.557, 2.344],
											[19.702, 5.566],
											[17.432, 9.033],
											[14.307, 10.156],
											[10.4, 10.303],
											[8.643, 10.205],
											[8.643, 21.338],
											[12.012, 21.509],
											[14.99, 21.533],
											[27.295, 17.896],
											[35.645, -0.879],
											[53.906, -53.223],
											[39.111, -53.223],
											[28.125, -13.965],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'y',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'y',
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'B',
			size: 16,
			style: 'Bold',
			w: 72.22,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[-3.142, 0.652],
											[-2.312, 1.758],
											[-1.367, 2.246],
											[0, 4.265],
											[1.871, 2.898],
											[3.678, 1.335],
											[-1.237, 1.498],
											[0, 4.395],
											[2.213, 3.06],
											[8.821, 0.13],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[3.141, -0.651],
											[2.051, -1.53],
											[2.148, -3.385],
											[0, -4.134],
											[-1.872, -2.897],
											[2.409, -1.237],
											[2.213, -2.669],
											[0, -4.264],
											[-3.679, -4.98],
											[0, 0],
											[0, 0],
											[0, 0],
											[3.678, 0],
										],
										v: [
											[50.708, -0.977],
											[58.887, -4.59],
											[64.014, -10.254],
											[67.236, -21.729],
											[64.429, -32.275],
											[56.104, -38.623],
											[61.572, -42.725],
											[64.893, -53.32],
											[61.572, -64.307],
											[42.822, -71.973],
											[7.861, -71.973],
											[7.861, 0],
											[40.479, 0],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'B',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
							{
								ind: 1,
								ty: 'sh',
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[-1.726, -0.781],
											[0, -3.743],
											[3.19, -1.562],
											[3.157, 0],
											[0, 0],
											[0, 0],
											[0, 0],
										],
										o: [
											[3.092, 1.4],
											[0, 4.427],
											[-1.758, 0.847],
											[0, 0],
											[0, 0],
											[0, 0],
											[3.125, 0.033],
										],
										v: [
											[47.412, -30.469],
											[52.051, -22.754],
											[47.266, -13.77],
											[39.893, -12.5],
											[22.217, -12.5],
											[22.217, -31.689],
											[40.137, -31.689],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'B',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
							{
								ind: 2,
								ty: 'sh',
								ix: 3,
								ks: {
									a: 0,
									k: {
										i: [
											[3.157, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[-2.246, -0.748],
											[0, -3.352],
											[1.953, -1.172],
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[3.483, 0],
											[2.604, 1.074],
											[0, 3.027],
											[-1.986, 1.205],
										],
										v: [
											[39.893, -43.604],
											[22.217, -43.604],
											[22.217, -59.473],
											[38.037, -59.473],
											[46.631, -58.35],
											[50.537, -51.709],
											[47.607, -45.41],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'B',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'B',
						np: 6,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
		{
			ch: 'o',
			size: 16,
			style: 'Bold',
			w: 61.08,
			data: {
				shapes: [
					{
						ty: 'gr',
						it: [
							{
								ind: 0,
								ty: 'sh',
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[9.147, 0],
											[4.492, -5.631],
											[0, -7.682],
											[-4.492, -5.55],
											[-9.148, 0],
											[-4.492, 5.55],
											[0, 7.812],
											[4.492, 5.632],
										],
										o: [
											[-9.148, 0],
											[-4.492, 5.632],
											[0, 7.812],
											[4.492, 5.55],
											[9.147, 0],
											[4.492, -5.55],
											[0, -7.682],
											[-4.492, -5.631],
										],
										v: [
											[30.42, -54.932],
											[9.961, -46.484],
											[3.223, -26.514],
											[9.961, -6.47],
											[30.42, 1.855],
											[50.879, -6.47],
											[57.617, -26.514],
											[50.879, -46.484],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'o',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
							{
								ind: 1,
								ty: 'sh',
								ix: 2,
								ks: {
									a: 0,
									k: {
										i: [
											[-2.181, -2.881],
											[0, -5.338],
											[2.18, -2.897],
											[4.069, 0],
											[2.197, 2.898],
											[0, 5.339],
											[-2.197, 2.881],
											[-4.07, 0],
										],
										o: [
											[2.18, 2.881],
											[0, 5.339],
											[-2.181, 2.898],
											[-4.07, 0],
											[-2.197, -2.897],
											[0, -5.338],
											[2.197, -2.881],
											[4.069, 0],
										],
										v: [
											[39.746, -38.843],
											[43.018, -26.514],
											[39.746, -14.16],
											[30.371, -9.814],
											[20.972, -14.16],
											[17.676, -26.514],
											[20.972, -38.843],
											[30.371, -43.164],
										],
										c: true,
									},
									ix: 2,
								},
								nm: 'o',
								mn: 'ADBE Vector Shape - Group',
								hd: false,
							},
						],
						nm: 'o',
						np: 5,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: 'ADBE Vector Group',
						hd: false,
					},
				],
			},
			fFamily: 'Helvetica',
		},
	],
};
